// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { PAYROLL_MOCK_DATA } from '../../data/payrollMockData';
// import payRollService from '../../services/PayrollService';

// const componentTypeMap = {
//   E: "Earning",
//   D: "Deduction",
//   C: "Contribution",
// };

// const calculationMethodMap = {
//   F: "Fixed",
//   P: "Percentage",
//   M: "Manual",
//   R: "Recurring",
//   S: "System Calculated",
// }

// const batchStatusMap = {
//   I: "Incomplete",
//   P: "Incomplete", // some test data returns P right now. There is no actual status called P, but this is added to keep the frontend looking clean.
//   A: "Authorized",
// }

// const payFrequencyMap = {
//   M: "Monthly",
//   W: "Weekly",
// }

// // Payroll Text/CEFT Report
// export const fetchPayrollDetailsByPeriod = createAsyncThunk(
//   'payroll/fetchPayrollDetailsByPeriod',
//   async (periodId, { rejectWithValue }) => {
//     try {
//       if (!periodId || !String(periodId).trim()) {
//         return rejectWithValue('Payroll period ID is required.');
//       }

//       const response = await payRollService.GetBankReportDetailsByPeriodId(Number(periodId));

//       const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
//       if (statusCode !== undefined && statusCode !== 200) {
//         throw new Error(response?.data?.Message || response?.Message || 'Failed to retrieve payroll details.');
//       }

//       const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

//       if (!Array.isArray(resultSet)) {
//         throw new Error('Invalid data format received.');
//       }

//       return {
//         periodId,
//         payrollDetails: resultSet,
//         count: resultSet.length,
//       };
//     } catch (error) {
//       return rejectWithValue(error.message || 'Failed to load payroll details.');
//     }
//   }
// );

// export const fetchBankReportsByDate = createAsyncThunk(
//   'payroll/fetchBankReportsByDate',
//   async (selectedDate, { rejectWithValue }) => {
//     try {
//       if (!selectedDate) {
//         return rejectWithValue('Date is required.');
//       }

//       const response = await payRollService.GetBankReportDetailsByDate(selectedDate);

//       const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
//       if (statusCode !== undefined && statusCode !== 200) {
//         throw new Error(response?.data?.Message || response?.Message || 'Failed to retrieve bank reports.');
//       }

//       const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

//       if (!Array.isArray(resultSet)) {
//         throw new Error('Invalid data format received.');
//       }

//       const formattedItems = resultSet.map((item) => ({
//         id: item.HBR_Tran_ID ?? item.HBR_Tran_Id ?? '0',
//         bankName: item.HBR_Bank_Name || '',
//         destinationBank: item.HBR_Destination_Bank || '',
//         branchName: item.HBR_Branch_Name || '',
//         destinationBr: item.HBR_Destination_Br || '',
//         branchSwiftCode: item.HBR_Branch_Swift_Code || '',
//         destinationAccount: item.HBR_Destination_Account || '',
//         destinationAccountName: item.HBR_Destination_Account_Name || '',
//         trnCode: item.HBR_TRN_Code ?? '0',
//         returnCode: item.HBR_Return_Code ?? '0',
//         crDrCode: item.HBR_Cr_Dr_Code ?? '0',
//         returnDate: item.HBR_Return_Date || '',
//         amount: item.HBR_Amount ?? '',
//         amountDecimal: item.HBR_Amount_Decimal ?? '',
//         currencyCode: item.HBR_Currency_Code || 'SLR',
//         originatingBank: item.HBR_Originating_Bank || '',
//         originatingBranch: item.HBR_Originating_Branch || '',
//         originatingAccount: item.HBR_Originating_Account || '',
//         originatingAccountName: item.HBR_Originating_Account_Name || '',
//         particulars: item.HBR_Particulars || '',
//         reference: item.HBR_Reference || '',
//         valueDate: item.HBR_Value_Date ?? '0',
//         securityField: item.HBR_Security_Field ?? '0',
//         filler: item.HBR_Filler || '@',
//         nicNumber: item.HBR_NIC_Number || '',
//       }));

//       return {
//         selectedDate,
//         items: formattedItems,
//         count: formattedItems.length,
//       };
//     } catch (error) {
//       return rejectWithValue(error.message || 'Failed to load bank reports.');
//     }
//   }
// );

// export const generateBankReport = createAsyncThunk(
//   'payroll/generateBankReport',
//   async ({ employee, periodId }, { rejectWithValue }) => {
//     try {
//       // Build payload
//       const BANK_CODE_MAP = {
//         BOC: '7010',
//         'National Savings Bank': '7719',
//         'Commercial Bank PLC': '7056',
//       };

//       const bankCode = employee.BANK_CODE || '';
//       const destinationBank = BANK_CODE_MAP[bankCode] || '';
//       const salary = Number(employee.NET_SALARY || 0);

//       const payload = {
//         p_Bank_Name: employee.BANK_NAME || '',
//         p_Destination_Bank: destinationBank,
//         p_Branch_Name: employee.BRANCH_NAME || '',
//         p_Destination_Br: employee.BRANCH_CODE || '',
//         p_Branch_Swift_Code: employee.SWIFT_CODE || '',
//         p_Destination_Account: employee.ACCOUNT_NUMBER || '',
//         p_Destination_Account_Name: employee.ACCOUNT_NAME || employee.REPORT_NAME || '',
//         p_Amount: Math.abs(salary),
//         p_Amount_Decimal: Math.abs(salary),
//         p_Particulars: employee.SERVICE_NO || '',
//         p_Reference: `Salary${periodId}`,
//         p_NIC_Number: employee.NIC_NO || '',
//         p_Created_By: 'admin',
//       };

//       const response = await payRollService.AddBankReport(payload);

//       const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
//       if (statusCode !== undefined && statusCode !== 200) {
//         throw new Error(response?.data?.Message || response?.Message || 'Failed to generate bank report.');
//       }

//       return {
//         serviceNo: employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown',
//         success: true,
//       };
//     } catch (error) {
//       const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';
//       return rejectWithValue({
//         serviceNo,
//         error: error.message || 'Failed to generate bank report.',
//       });
//     }
//   }
// );

// export const generateMultipleBankReports = createAsyncThunk(
//   'payroll/generateMultipleBankReports',
//   async ({ employees, periodId, selectedDate }, { dispatch, rejectWithValue }) => {
//     try {
//       const results = {
//         success: [],
//         failed: [],
//         skipped: [],
//         statuses: {},
//       };

//       // Validate each employee first
//       const validEmployees = employees.filter(employee => {
//         const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';
//         const errors = [];

//         if (!employee.BANK_NAME) errors.push('Bank Name');
//         const accountNumber = employee.ACCOUNT_NUMBER || '';
//         if (!accountNumber || accountNumber === '-' || accountNumber === 'N/A') {
//           errors.push('Valid Account Number');
//         }
//         if (!employee.BRANCH_CODE) errors.push('Branch Code');
//         const salary = Number(employee.NET_SALARY || 0);
//         if (salary === 0) errors.push('Non-zero Salary');

//         if (errors.length) {
//           results.skipped.push({ serviceNo, reason: errors.join(', ') });
//           results.statuses[serviceNo] = { status: 'skipped', reason: errors.join(', ') };
//           return false;
//         }
//         return true;
//       });

//       if (!validEmployees.length) {
//         return rejectWithValue({
//           message: 'No valid employees found.',
//           results,
//         });
//       }

//       // Process each valid employee
//       for (const employee of validEmployees) {
//         const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';

//         try {
//           results.statuses[serviceNo] = { status: 'processing' };

//           const result = await dispatch(generateBankReport({
//             employee,
//             periodId,
//           })).unwrap();

//           results.success.push(serviceNo);
//           results.statuses[serviceNo] = { status: 'success' };
//         } catch (error) {
//           const errorMsg = error?.error || error?.message || 'Unknown error';
//           results.failed.push({ serviceNo, error: errorMsg });
//           results.statuses[serviceNo] = { status: 'failed', reason: errorMsg };
//         }
//       }

//       // Refresh bank reports after generation
//       await dispatch(fetchBankReportsByDate(selectedDate));

//       return results;
//     } catch (error) {
//       return rejectWithValue(error.message || 'Failed to generate bank reports.');
//     }
//   }
// );

// // Fetch all entities (existing)
// export const fetchPayrollEntityList = createAsyncThunk(
//   'payroll/fetchEntityList',
//   async (entityKey, { rejectWithValue }) => {
//     try {
//       let list = [];
//       if (entityKey === 'payrollPeriods') {
//         const response = await payRollService.GetPayRollPeriodList();
//         list = (response.data?.ResultSet || []).map((item) => ({
//           id: item.HPP_PAYROLL_PERIOD_ID,
//           code: item.HPP_PERIOD_CODE,
//           name: item.HPP_PERIOD_NAME,
//           year: item.HPP_YEAR,
//           month: item.HPP_MONTH,

//           frequency: payFrequencyMap[item.HPP_PAY_FREQUENCY] ?? item.HPP_PAY_FREQUENCY,

//           startDate: item.HPP_PAYROLL_START_DATE?.split(' ')[0],
//           endDate: item.HPP_PAYROLL_END_DATE,
//           attendanceStartDate: item.HPP_ATTENDANCE_START_DATE?.split(' ')[0],
//           attendanceEndDate: item.HPP_ATTENDANCE_END_DATE,
//           otStartDate: item.HPP_OT_START_DATE?.split(' ')[0],
//           otEndDate: item.HPP_OT_END_DATE,
//           payDate: item.HPP_PAYMENT_DATE?.split(' ')[0],
//           status: item.HPP_STATUS === 'A' ? 'Active' : 'Inactive',
//           isLocked: item.HPP_IS_LOCKED === 'True',
//           glPosted: item.HPP_GL_POSTED === 'True',
//           bankTransferGenerated: item.HPP_BANK_TRANSFER_GENERATED === 'True',
//           isActive: item.HPP_IS_ACTIVE === 'True',
//           remarks: item.HPP_REMARKS,
//         }));
//       } else if (entityKey === 'payrollComponents') {
//         const response = await payRollService.GetPayRollComponentList();
//         list = (response.data?.ResultSet || []).map((item) => ({
//           id: item.HPC_COMPONENT_ID,
//           code: item.HPC_COMPONENT_CODE,
//           name: item.HPC_COMPONENT_NAME,
//           type: componentTypeMap[item.HPC_COMPONENT_TYPE] ?? item.HPC_COMPONENT_TYPE,
//           calcMethod: calculationMethodMap[item.HPC_CALCULATION_METHOD] ?? item.HPC_CALCULATION_METHOD,
//           defaultAmount: Number(item.HPC_DEFAULT_AMOUNT || 0),
//           defaultPercentage: Number(item.HPC_DEFAULT_PERCENTAGE || 0),
//           basic: item.HPC_IS_BASIC === 'True',
//           taxable: item.HPC_IS_TAXABLE === 'True',
//           epf: item.HPC_IS_EPF === 'True',
//           etf: item.HPC_IS_ETF === 'True',
//           otPayable: item.HPC_IS_OT === 'True',
//           printOnPayslip: item.HPC_PRINT_ON_PAYSLIP === 'True',
//           glAccountCode: item.HPC_GL_ACCOUNT_CODE,
//           sortOrder: Number(item.HPC_SORT_ORDER || 0),
//           status: item.HPC_IS_ACTIVE === 'True' ? 'Active' : 'Inactive',
//           remarks: item.HPC_REMARKS,
//         }));
//       }
//       else if (entityKey === "employeeSalary") {
//         const response = await payRollService.GetEmployeeSalaryList();

//         list = (response.data.ResultSet || []).map((item) => ({
//           id: item.HES_EMPLOYEE_SALARY_ID,

//           employeeId: item.HES_EMPLOYEE_ID,
//           empNo: item.HED_SERVICE_NO,
//           name: item.HED_REPORT_NAME,

//           payrollPeriodId: item.HES_PAYROLL_PERIOD_ID,
//           salaryReference: item.HES_SALARY_REFERENCE,

//           effectiveDate: item.HES_EFFECTIVE_DATE?.split(" ")[0],
//           endDate: item.HES_END_DATE?.split(" ")[0],

//           payFrequency: payFrequencyMap[item.HES_PAY_FREQUENCY],

//           basic: Number(item.HES_BASIC_SALARY || 0),
//           grossSalary: Number(item.HES_GROSS_SALARY || 0),

//           workingDays: Number(item.HES_STANDARD_WORKING_DAYS || 0),
//           workingHours: Number(item.HES_STANDARD_WORKING_HOURS || 0),

//           hourlyRate: Number(item.HES_HOURLY_RATE || 0),
//           dailyRate: Number(item.HES_DAILY_RATE || 0),

//           isCurrent: item.HES_IS_CURRENT === "True",
//           isActive: item.HES_IS_ACTIVE === "True",

//           remarks: item.HES_REMARKS,

//           status:
//             item.HES_IS_CURRENT === "True"
//               ? "Current"
//               : "Inactive",
//         }));
//       }
//       else if (entityKey === "employeeSalaryComponents") {
//         const response = await payRollService.GetEmployeeSalaryComponentList();

//         list = (response.data.ResultSet || []).map((item) => ({
//           id: item.HSC_EMPLOYEE_SALARY_COMPONENT_ID,

//           employeeSalaryId: item.HSC_EMPLOYEE_SALARY_ID,
//           employeeId: item.HES_EMPLOYEE_ID,

//           empNo: item.HED_SERVICE_NO,
//           name: item.EMPLOYEE_NAME,

//           componentId: item.HSC_COMPONENT_ID,

//           amount: Number(item.HSC_AMOUNT || 0),
//           percentage: Number(item.HSC_PERCENTAGE || 0),

//           effectiveDate: item.HSC_EFFECTIVE_DATE?.split(" ")[0],
//           endDate: item.HSC_END_DATE?.split(" ")[0],

//           isActive: item.HSC_IS_ACTIVE === "True",

//           remarks: item.HSC_REMARKS,
//         }));
//       }
//       else if (entityKey === "batchManagement") {
//         const response = await payRollService.GetPayRollBatchList();

//         list = (response.data.ResultSet || []).map((item) => ({
//           id: item.HPB_BATCH_ID,

//           batchNo: item.HPB_BATCH_NO,
//           name: item.HPB_BATCH_NAME,

//           periodId: item.HPB_PAYROLL_PERIOD_ID,
//           componentId: item.HPB_COMPONENT_ID,

//           calculationMethod: calculationMethodMap[item.HPB_CALCULATION_METHOD] ??
//             item.HPB_CALCULATION_METHOD,

//           amount: Number(item.HPB_AMOUNT || 0),
//           percentage: Number(item.HPB_PERCENTAGE || 0),

//           effectiveDate: item.HPB_EFFECTIVE_DATE?.split(" ")[0],
//           description: item.HPB_DESCRIPTION,

//           status: batchStatusMap[item.HPB_STATUS] ??
//             item.HPB_STATUS,

//           approvedBy: item.HPB_APPROVED_BY,
//           postedBy: item.HPB_POSTED_BY,
//           createdBy: item.HPB_CREATED_BY,
//           updatedBy: item.HPB_UPDATED_BY,

//           isActive: item.HPB_IS_ACTIVE === "True",
//           remarks: item.HPB_REMARKS,
//         }))
//       }
//       else if (entityKey === "overtimeEntry") {
//         const response = await payRollService.GetOvertimeList();

//         list = (response.data.ResultSet || []).map((item) => {
//           const isApproved = item.HOT_IS_APPROVED === "True";

//           return {
//             id: item.HOT_OVERTIME_ID,

//             employeeId: item.HOT_EMPLOYEE_ID,
//             // empNo: item.HOT_OVERTIME_ID,
//             // name: item.HOT_OVERTIME_ID,

//             payrollPeriodId: item.HOT_PAYROLL_PERIOD_ID,
//             payrollId: item.HOT_PAYROLL_ID,

//             date: item.HOT_OT_DATE?.split(" ")[0],
//             otType: item.HOT_OT_TYPE,
//             startTime: item.HOT_START_TIME,
//             endTime: item.HOT_END_TIME,

//             hours: Number(item.HOT_TOTAL_HOURS),
//             rate: Number(item.HOT_OT_RATE),
//             amount: Number(item.HOT_OT_AMOUNT),

//             isApproved,
//             approvedBy: item.HOT_APPROVED_BY,
//             createdBy: item.HOT_CREATED_BY,
//             isActive: item.HOT_IS_ACTIVE,

//             status: isApproved ? "Approved" : "Pending",
//           }
//         })
//       }
//       else if (entityKey === "loanManagement") {
//         const response = await payRollService.GetLoanList();

//         list = (response.data.ResultSet || []).map(item => ({
//           id: item.HLM_LOAN_ID,

//           employeeId: item.HLM_EMPLOYEE_ID,
//           empNo: item.HED_SERVICE_NO,
//           name: item.HED_REPORT_NAME,

//           loanNo: item.HLM_LOAN_NO,
//           loanType: item.HLM_LOAN_TYPE,
//           loanDescription: item.HLM_LOAN_DESCRIPTION,

//           loanDate: item.HLM_LOAN_DATE?.split(" ")[0],
//           approvedDate: item.HLM_APPROVED_DATE?.split(" ")[0],

//           amount: Number(item.HLM_LOAN_AMOUNT || 0),

//           interestRate: Number(item.HLM_INTEREST_RATE || 0),

//           totalInterest: Number(item.HLM_TOTAL_INTEREST || 0),

//           totalAmount: Number(item.HLM_TOTAL_AMOUNT || 0),

//           installments: Number(item.HLM_NO_OF_INSTALLMENTS || 0),

//           installmentAmount: Number(item.HLM_INSTALLMENT_AMOUNT || 0),

//           startPeriodId: item.HLM_START_PERIOD_ID,
//           endPeriodId: item.HLM_END_PERIOD_ID,

//           balance: Number(item.HLM_BALANCE_AMOUNT || 0),

//           status: item.HLM_STATUS === "P" ? "Pending" : "Other",

//           approvedBy: item.HLM_APPROVED_BY,
//           createdBy: item.HLM_CREATED_BY,
//           createdDate: item.HLM_CREATED_DATE,
//           updatedBy: item.HLM_UPDATED_BY,
//           updatedDate: item.HLM_UPDATED_DATE,
//           isActive: item.HLM_IS_ACTIVE,
//           remarks: item.HLM_REMARKS,
//         }))
//       } else if (entityKey === "loanInstallments") {
//         const response = await payRollService.GetLoanList();

//         list = (response.data.ResultSet || []).map(item => ({
//           id: item.HLM_LOAN_ID,

//           employeeId: item.HLM_EMPLOYEE_ID,
//           empNo: item.HED_SERVICE_NO,
//           name: item.HED_REPORT_NAME,

//           loanNo: item.HLM_LOAN_NO,
//           loanType: item.HLM_LOAN_TYPE,
//           loanDescription: item.HLM_LOAN_DESCRIPTION,

//           loanDate: item.HLM_LOAN_DATE?.split(" ")[0],
//           approvedDate: item.HLM_APPROVED_DATE?.split(" ")[0],

//           amount: Number(item.HLM_LOAN_AMOUNT || 0),

//           interestRate: Number(item.HLM_INTEREST_RATE || 0),

//           totalInterest: Number(item.HLM_TOTAL_INTEREST || 0),

//           totalAmount: Number(item.HLM_TOTAL_AMOUNT || 0),

//           installments: Number(item.HLM_NO_OF_INSTALLMENTS || 0),

//           installmentAmount: Number(item.HLM_INSTALLMENT_AMOUNT || 0),

//           startPeriodId: item.HLM_START_PERIOD_ID,
//           endPeriodId: item.HLM_END_PERIOD_ID,

//           balance: Number(item.HLM_BALANCE_AMOUNT || 0),

//           status: item.HLM_STATUS === "P" ? "Pending" : "Other",

//           approvedBy: item.HLM_APPROVED_BY,
//           createdBy: item.HLM_CREATED_BY,
//           createdDate: item.HLM_CREATED_DATE,
//           updatedBy: item.HLM_UPDATED_BY,
//           updatedDate: item.HLM_UPDATED_DATE,
//           isActive: item.HLM_IS_ACTIVE,
//           remarks: item.HLM_REMARKS,
//         }))
//       }
//       else {
//         list = PAYROLL_MOCK_DATA[entityKey] || [];
//       }
//       return { entityKey, list };
//     } catch (error) {
//       const fallbackList = PAYROLL_MOCK_DATA[entityKey];
//       if (fallbackList) {
//         return { entityKey, list: fallbackList };
//       }
//       return rejectWithValue({ entityKey, msg: error.message || error.toString() });
//     }
//   }
// );

// export const fetchBankReportDetailsByDate = createAsyncThunk(
//   'payroll/fetchBankReportDetailsByDate',
//   async (createdDate, { rejectWithValue }) => {
//     try {
//       const response = await payRollService.GetBankReportDetailsByDate(createdDate);

//       if (!response) {
//         throw new Error('No response received from server.');
//       }

//       const statusCode = response?.data?.StatusCode || response?.StatusCode;
//       if (statusCode !== 200) {
//         throw new Error(response?.data?.Message || 'Failed to retrieve bank report details.');
//       }

//       const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

//       if (!Array.isArray(resultSet)) {
//         throw new Error('Invalid data format received.');
//       }

//       if (resultSet.length === 0) {
//         return rejectWithValue('No bank reports found for this date.');
//       }

//       const hasRealData = resultSet.some(
//         (item) => item.HBR_Bank_Name || item.HBR_Destination_Account || item.HBR_Amount
//       );

//       if (!hasRealData) {
//         return rejectWithValue('No valid data found for this date.');
//       }

//       const formattedItems = resultSet.map((item) => ({
//         id: item.HBR_Tran_ID || '0',
//         bankName: item.HBR_Bank_Name || '',
//         destinationBank: item.HBR_Destination_Bank || '',
//         branchName: item.HBR_Branch_Name || '',
//         destinationBr: item.HBR_Destination_Br || '',
//         branchSwiftCode: item.HBR_Branch_Swift_Code || '',
//         destinationAccount: item.HBR_Destination_Account || '',
//         destinationAccountName: item.HBR_Destination_Account_Name || '',
//         trnCode: item.HBR_TRN_Code || '0',
//         returnCode: item.HBR_Return_Code || '0',
//         crDrCode: item.HBR_Cr_Dr_Code || '0',
//         returnDate: item.HBR_Return_Date || '',
//         amount: item.HBR_Amount || '',
//         amountDecimal: item.HBR_Amount_Decimal || '',
//         currencyCode: item.HBR_Currency_Code || 'SLR',
//         originatingAccount: item.HBR_Originating_Account || '',
//         originatingAccountName: item.HBR_Originating_Account_Name || '',
//         particulars: item.HBR_Particulars || '',
//         reference: item.HBR_Reference || '',
//         valueDate: item.HBR_Value_Date || '0',
//         securityField: item.HBR_Security_Field || '0',
//         filler: item.HBR_Filler || '@',
//         nicNumber: item.HBR_NIC_Number || '',
//       }));

//       return formattedItems;
//     } catch (error) {
//       return rejectWithValue(error.message || error.toString());
//     }
//   }
// );

// export const fetchCurrentPeriodId = createAsyncThunk(
//   'payroll/fetchCurrentPeriodId',
//   async (_, { rejectWithValue }) => {
//     try {
//       const periodId = await payRollService.GetCurrentPeriodId();
//       if (!periodId) {
//         return rejectWithValue('No current payroll period found.');
//       }
//       return periodId;
//     } catch (error) {
//       return rejectWithValue(error.message || 'Failed to fetch current period ID.');
//     }
//   }
// );

// const emptyEntity = { list: [], loading: false, saving: false, msg: null };

// const payrollSlice = createSlice({
//   name: 'payroll',
//   initialState: {
//     entities: {},
//     // Payroll Text specific state
//     payrollText: {
//       periodId: '',
//       currentPeriodId: null,
//       selectedDate: '',
//       payrollDetails: [],
//       bankReports: [],
//       loading: false,
//       generating: false,
//       generationStatus: {},
//       error: null,
//       success: null,
//     },
//     bankReport: {
//       items: [],
//       loading: false,
//       error: null,
//     },
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     saveEntity: (state, action) => {
//       const { entityKey, record, isEdit } = action.payload;
//       const entity = state.entities[entityKey] || emptyEntity;
//       const list = isEdit
//         ? entity.list.map((row) => (row.id === record.id ? { ...row, ...record } : row))
//         : [{ ...record, id: record.id || `${entityKey}-${Date.now()}` }, ...entity.list];

//       state.entities[entityKey] = {
//         ...entity,
//         saving: false,
//         list,
//       };
//     },
//     removeEntity: (state, action) => {
//       const { entityKey, id } = action.payload;
//       const entity = state.entities[entityKey] || emptyEntity;
//       state.entities[entityKey] = {
//         ...entity,
//         list: entity.list.filter((row) => row.id !== id),
//       };
//     },
//     // Payroll Text specific reducers
//     setPayrollPeriodId: (state, action) => {
//       state.payrollText.periodId = action.payload;
//     },
//     setSelectedDate: (state, action) => {
//       state.payrollText.selectedDate = action.payload;
//     },
//     clearPayrollTextError: (state) => {
//       state.payrollText.error = null;
//       state.payrollText.success = null;
//     },
//     resetPayrollText: (state) => {
//       state.payrollText = {
//         periodId: '',
//         currentPeriodId: null,
//         selectedDate: '',
//         payrollDetails: [],
//         bankReports: [],
//         loading: false,
//         generating: false,
//         generationStatus: {},
//         error: null,
//         success: null,
//       };
//     },
//     clearGenerationStatus: (state) => {
//       state.payrollText.generationStatus = {};
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch Payroll Details by Period
//       .addCase(fetchPayrollDetailsByPeriod.pending, (state) => {
//         state.payrollText.loading = true;
//         state.payrollText.error = null;
//       })
//       .addCase(fetchPayrollDetailsByPeriod.fulfilled, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.payrollDetails = action.payload.payrollDetails;
//         state.payrollText.periodId = action.payload.periodId;
//         state.payrollText.error = null;
//         state.payrollText.success = `${action.payload.count} payroll record(s) loaded.`;
//       })
//       .addCase(fetchPayrollDetailsByPeriod.rejected, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.payrollDetails = [];
//         state.payrollText.error = action.payload || 'Failed to load payroll details.';
//         state.payrollText.success = null;
//       })

//       // Fetch Bank Reports by Date
//       .addCase(fetchBankReportsByDate.pending, (state) => {
//         state.payrollText.loading = true;
//         state.payrollText.error = null;
//       })
//       .addCase(fetchBankReportsByDate.fulfilled, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.bankReports = action.payload.items;
//         state.payrollText.selectedDate = action.payload.selectedDate;
//         state.payrollText.error = null;
//       })
//       .addCase(fetchBankReportsByDate.rejected, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.bankReports = [];
//         state.payrollText.error = action.payload || 'Failed to load bank reports.';
//       })

//       // Generate Multiple Bank Reports
//       .addCase(generateMultipleBankReports.pending, (state) => {
//         state.payrollText.generating = true;
//         state.payrollText.error = null;
//         state.payrollText.generationStatus = {};
//       })
//       .addCase(generateMultipleBankReports.fulfilled, (state, action) => {
//         state.payrollText.generating = false;
//         state.payrollText.generationStatus = action.payload.statuses || {};

//         const { success, failed, skipped } = action.payload;
//         let message = `Generated ${success.length} bank report(s).`;
//         if (failed.length > 0) message += ` ${failed.length} failed.`;
//         if (skipped.length > 0) message += ` ${skipped.length} skipped.`;
//         state.payrollText.success = message;

//         if (failed.length > 0) {
//           state.payrollText.error = `Failed for: ${failed.slice(0, 3).map(f => f.serviceNo).join(', ')}${failed.length > 3 ? `... and ${failed.length - 3} more` : ''}`;
//         }
//       })
//       .addCase(generateMultipleBankReports.rejected, (state, action) => {
//         state.payrollText.generating = false;
//         state.payrollText.error = action.payload?.message || 'Failed to generate bank reports.';
//         if (action.payload?.results) {
//           state.payrollText.generationStatus = action.payload.results.statuses || {};
//         }
//       })

//       // Existing entity fetch
//       .addCase(fetchPayrollEntityList.pending, (state, action) => {
//         const entityKey = action.meta.arg;
//         const entity = state.entities[entityKey] || emptyEntity;
//         state.entities[entityKey] = { ...entity, loading: true, msg: null };
//       })
//       .addCase(fetchPayrollEntityList.fulfilled, (state, action) => {
//         const { entityKey, list } = action.payload;
//         const entity = state.entities[entityKey] || emptyEntity;
//         state.entities[entityKey] = { ...entity, loading: false, saving: false, list };
//       })
//       .addCase(fetchPayrollEntityList.rejected, (state, action) => {
//         const entityKey = action.payload?.entityKey || action.meta.arg;
//         const entity = state.entities[entityKey] || emptyEntity;
//         state.entities[entityKey] = { ...entity, loading: false, msg: action.payload?.msg || action.error.message };
//       })

//       // Bank Report Details (existing)
//       .addCase(fetchBankReportDetailsByDate.pending, (state) => {
//         state.bankReport.loading = true;
//         state.bankReport.error = null;
//       })
//       .addCase(fetchBankReportDetailsByDate.fulfilled, (state, action) => {
//         state.bankReport.loading = false;
//         state.bankReport.items = action.payload;
//         state.bankReport.error = null;
//       })
//       .addCase(fetchBankReportDetailsByDate.rejected, (state, action) => {
//         state.bankReport.loading = false;
//         state.bankReport.items = [];
//         state.bankReport.error = action.payload || action.error.message;
//       })

//       // Fetch Current Period ID
//       .addCase(fetchCurrentPeriodId.pending, (state) => {
//         state.payrollText.loading = true;
//         state.payrollText.error = null;
//       })
//       .addCase(fetchCurrentPeriodId.fulfilled, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.currentPeriodId = action.payload;
//         state.payrollText.error = null;
//       })
//       .addCase(fetchCurrentPeriodId.rejected, (state, action) => {
//         state.payrollText.loading = false;
//         state.payrollText.currentPeriodId = null;
//         state.payrollText.error = action.payload || 'Failed to fetch current period ID.';
//       });
//   },
// });

// export const {
//   saveEntity,
//   removeEntity,
//   setPayrollPeriodId,
//   setSelectedDate,
//   clearPayrollTextError,
//   resetPayrollText,
//   clearGenerationStatus,
// } = payrollSlice.actions;

// // Selectors for Payroll Text
// export const selectPayrollTextState = (state) => state.payroll.payrollText;
// export const selectPayrollDetails = (state) => state.payroll.payrollText.payrollDetails;
// export const selectBankReports = (state) => state.payroll.payrollText.bankReports;
// export const selectPayrollTextLoading = (state) => state.payroll.payrollText.loading;
// export const selectPayrollTextGenerating = (state) => state.payroll.payrollText.generating;
// export const selectPayrollTextError = (state) => state.payroll.payrollText.error;
// export const selectPayrollTextSuccess = (state) => state.payroll.payrollText.success;
// export const selectPayrollTextPeriodId = (state) => state.payroll.payrollText.periodId;
// export const selectPayrollTextSelectedDate = (state) => state.payroll.payrollText.selectedDate;
// export const selectGenerationStatus = (state) => state.payroll.payrollText.generationStatus;
// export const selectCurrentPeriodId = (state) => state.payroll.payrollText.currentPeriodId;

// // Existing selectors
// export const selectEntities = (state) => state.payroll.entities;
// export const selectEntity = (entityKey) => (state) => state.payroll.entities[entityKey] || emptyEntity;
// export const selectBankReport = (state) => state.payroll.bankReport;

// export default payrollSlice.reducer;

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import payRollService from '../../services/PayrollService';
import { getLoggedInServiceNo, pick } from '../../utils/masterDataUtils';


const PAYROLL_SAVE_REQUEST = 'PAYROLL_SAVE_REQUEST';
const PAYROLL_SAVE_SUCCESS = 'PAYROLL_SAVE_SUCCESS';
const PAYROLL_SAVE_FAIL = 'PAYROLL_SAVE_FAIL';

const delay = (ms = 300) => new Promise((resolve) => setTimeout(resolve, ms));

/** "2026-09-01 00:00:00" -> "2026-09-01" */
const formatDate = (value) => String(value ?? '').split(' ')[0];

const componentTypeMap = {
  E: "Earning",
  D: "Deduction",
  C: "Contribution",
};

const calculationMethodMap = {
  F: "Fixed",
  P: "Percentage",
  M: "Manual",
  R: "Recurring",
  S: "System Calculated",
}

const batchStatusMap = {
  I: "Incomplete",
  P: "Incomplete", // some test data returns P right now. There is no actual status called P, but this is added to keep the frontend looking clean.
  A: "Authorized",
}

const payFrequencyMap = {
  M: "Monthly",
  W: "Weekly",
}

const earningCategoryMap = {
  F: "Fixed",
  V: "Variable",
  "": "None",
  null: "None",
}

export const fetchPayrollBreakdown = createAsyncThunk(
  'payroll/fetchPayrollBreakdown',
  async ({ periodId, serviceNo }, { rejectWithValue }) => {
    try {
      if (!periodId || !serviceNo) {
        return rejectWithValue('Period ID and Service No are required.');
      }

      const response = await payRollService.GetPayrollDetailsBySno(
        Number(periodId),
        serviceNo
      );

      const statusCode =
        response?.data?.StatusCode ??
        response?.StatusCode ??
        response?.status;

      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(
          response?.data?.Message || 'Failed to retrieve payroll breakdown.'
        );
      }

      const resultSet =
        response?.data?.ResultSet || response?.ResultSet || null;

      if (!resultSet || typeof resultSet !== 'object') {
        throw new Error(
          'The payroll for this period has not been generated.'
        );
      }

      // ── Payroll header (summary) ──
      const header = {
        payrollId: resultSet.HPH_PAYROLL_ID,
        payrollNo: resultSet.HPH_PAYROLL_NO,
        payrollPeriodId: resultSet.HPH_PAYROLL_PERIOD_ID,
        employeeId: resultSet.HPH_EMPLOYEE_ID,
        payDate: resultSet.HPH_PAY_DATE,
        status: resultSet.HPH_STATUS,

        workingDays: Number(resultSet.HPH_WORKING_DAYS || 0),
        presentDays: Number(resultSet.HPH_PRESENT_DAYS || 0),
        noPayDays: Number(resultSet.HPH_NO_PAY_DAYS || 0),
        otHours: Number(resultSet.HPH_OT_HOURS || 0),

        totalEarnings: Number(resultSet.HPH_TOTAL_EARNINGS || 0),
        totalDeductions: Number(resultSet.HPH_TOTAL_DEDUCTIONS || 0),
        netSalary: Number(resultSet.HPH_NET_SALARY || 0),
        grossEarnings: Number(resultSet.HPH_GROSS_EARNINGS || 0),

        employeeEpf: Number(resultSet.HPH_EMPLOYEE_EPF || 0),
        employerEpf: Number(resultSet.HPH_EMPLOYER_EPF || 0),
        employerEtf: Number(resultSet.HPH_EMPLOYER_ETF || 0),
        paye: Number(resultSet.HPH_PAYE || 0),

        remarks: resultSet.HPH_REMARKS || '',
      };

      // ── Detail line items ──
      const detailArray = Array.isArray(resultSet.PayrollDetails)
        ? resultSet.PayrollDetails
        : [];

      const rows = detailArray.map((r, idx) => ({
        id: r.HPD_PAYROLL_DETAIL_ID || `row-${idx}`,
        componentId: r.HPD_COMPONENT_ID,
        componentCode: r.HPC_COMPONENT_CODE,
        componentName: r.HPC_COMPONENT_NAME,
        componentType: r.HPC_COMPONENT_TYPE, // 'E' | 'D' | 'C'
        description: r.HPD_DESCRIPTION,
        amount: Number(r.HPD_AMOUNT || 0),
        quantity: r.HPD_QUANTITY === '' ? null : Number(r.HPD_QUANTITY),
        percentage:
          r.HPD_PERCENTAGE === '' ? null : Number(r.HPD_PERCENTAGE),
        isSystemGenerated: r.HPD_IS_SYSTEM_GENERATED === 'True',
        remarks: r.HPD_REMARKS,
      }));

      const earnings = rows.filter((r) => r.componentType === 'E');
      const deductions = rows.filter((r) => r.componentType === 'D');
      const contributions = rows.filter((r) => r.componentType === 'C');

      // Prefer summed detail totals; fall back to header totals when empty.
      const summedEarnings = earnings.reduce((s, r) => s + r.amount, 0);
      const summedDeductions = deductions.reduce((s, r) => s + r.amount, 0);

      const totalEarnings = rows.length
        ? summedEarnings
        : header.totalEarnings;
      const totalDeductions = rows.length
        ? summedDeductions
        : header.totalDeductions;
      const netSalary = rows.length
        ? totalEarnings - totalDeductions
        : header.netSalary;

      return {
        serviceNo,
        periodId,
        header,
        rows,
        earnings,
        deductions,
        contributions,
        totalEarnings,
        totalDeductions,
        netSalary,
      };
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to load payroll breakdown.'
      );
    }
  }
);

// Payroll Text/CEFT Report
export const fetchPayrollDetailsByPeriod = createAsyncThunk(
  'payroll/fetchPayrollDetailsByPeriod',
  async (periodId, { rejectWithValue }) => {
    console.log('[fetchPayrollDetailsByPeriod] Called with periodId:', periodId);

    try {
      if (!periodId || !String(periodId).trim()) {
        console.log('[fetchPayrollDetailsByPeriod] Invalid periodId, rejecting');
        return rejectWithValue('Payroll period ID is required.');
      }

      console.log('[fetchPayrollDetailsByPeriod] Calling API with periodId:', periodId);
      const response = await payRollService.GetBankReportDetailsByPeriodId(Number(periodId));
      console.log('[fetchPayrollDetailsByPeriod] API Response received:', response);

      const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
      console.log('[fetchPayrollDetailsByPeriod] Status code:', statusCode);

      if (statusCode !== undefined && statusCode !== 200) {
        console.log('[fetchPayrollDetailsByPeriod] Non-200 status code:', statusCode);
        throw new Error(response?.data?.Message || response?.Message || 'Failed to retrieve payroll details.');
      }

      const resultSet = response?.data?.ResultSet || response?.ResultSet || [];
      console.log('[fetchPayrollDetailsByPeriod] ResultSet length:', resultSet.length);
      console.log('[fetchPayrollDetailsByPeriod] Full ResultSet:', resultSet);

      if (!Array.isArray(resultSet)) {
        console.log('[fetchPayrollDetailsByPeriod] ResultSet is not an array');
        throw new Error('Invalid data format received.');
      }

      // Debug: Log the first employee to see what fields are available
      if (resultSet.length > 0) {
        console.log('[fetchPayrollDetailsByPeriod] First employee object:', resultSet[0]);
        console.log('[fetchPayrollDetailsByPeriod] First employee keys:', Object.keys(resultSet[0]));
        console.log('[fetchPayrollDetailsByPeriod] NIC fields found:', {
          NIC_NO: resultSet[0].NIC_NO,
          NIC_Number: resultSet[0].NIC_Number,
          NIC: resultSet[0].NIC,
          HED_NIC_NO: resultSet[0].HED_NIC_NO,
          HBR_NIC_Number: resultSet[0].HBR_NIC_Number,
        });
      } else {
        console.log('[fetchPayrollDetailsByPeriod] ResultSet is empty!');
      }

      return {
        periodId,
        payrollDetails: resultSet,
        count: resultSet.length,
      };
    } catch (error) {
      console.error('[fetchPayrollDetailsByPeriod] Error:', error);
      return rejectWithValue(error.message || 'Failed to load payroll details.');
    }
  }
);

export const fetchBankReportsByDate = createAsyncThunk(
  'payroll/fetchBankReportsByDate',
  async (selectedDate, { rejectWithValue }) => {
    try {
      if (!selectedDate) {
        return rejectWithValue('Date is required.');
      }

      const response = await payRollService.GetBankReportDetailsByDate(selectedDate);

      console.log('[fetchBankReportsByDate] Raw first item:', response?.data?.ResultSet?.[0]);

      const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(response?.data?.Message || response?.Message || 'Failed to retrieve bank reports.');
      }

      const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

      if (!Array.isArray(resultSet)) {
        throw new Error('Invalid data format received.');
      }

      const formattedItems = resultSet.map((item) => ({
        id: item.HBR_Tran_ID ?? item.HBR_Tran_Id ?? '0',
        bankName: item.HBR_Bank_Name || '',
        destinationBank: item.HBR_Destination_Bank || '',
        branchName: item.HBR_Branch_Name || '',
        destinationBr: item.HBR_Destination_Br || '',
        branchSwiftCode: item.HBR_Branch_Swift_Code || '',
        destinationAccount: item.HBR_Destination_Account || '',
        destinationAccountName: item.HBR_Destination_Account_Name || '',
        trnCode: item.HBR_TRN_Code ?? '0',
        returnCode: item.HBR_Return_Code ?? '0',
        crDrCode: item.HBR_Cr_Dr_Code ?? '0',
        returnDate: item.HBR_Return_Date || '',
        amount: item.HBR_Amount ?? '',
        amountDecimal: item.HBR_Amount_Decimal ?? '',
        currencyCode: item.HBR_Currency_Code || 'SLR',
        originatingBank: item.HBR_Originating_Bank || '',
        originatingBranch: item.HBR_Originating_Branch || '',
        originatingAccount: item.HBR_Originating_Account || '',
        originatingAccountName: item.HBR_Originating_Account_Name || '',
        particulars: item.HBR_Particulars || '',
        reference: item.HBR_Reference || '',
        valueDate: item.HBR_Value_Date ?? '0',
        securityField: item.HBR_Security_Field ?? '0',
        filler: item.HBR_Filler || '@',
        nicNumber: item.HBR_NIC_Number || '',
        month: item.HBR_Month != null && item.HBR_Month !== '' ? Number(item.HBR_Month) : null,
        HBR_Month: item.HBR_Month || '',          // ← add this
        year: item.HBR_Year != null && item.HBR_Year !== '' ? Number(item.HBR_Year) : null,
        HBR_Year: item.HBR_Year || '',            // ← add this
      }));

      return {
        selectedDate,
        items: formattedItems,
        count: formattedItems.length,
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load bank reports.');
    }
  }
);

//Generate a single bank report for an employee

export const generateBankReport = createAsyncThunk(
  'payroll/generateBankReport',
  async ({ employee, periodId }, { rejectWithValue }) => {
    try {
      console.log('[generateBankReport] Processing employee:', {
        id: employee.EMPLOYEE_ID || employee.id,
        serviceNo: employee.SERVICE_NO,
        name: employee.REPORT_NAME || employee.ACCOUNT_NAME,
        bank: employee.BANK_NAME,
        account: employee.ACCOUNT_NUMBER,
        salary: employee.NET_SALARY,
      });

      const salary = Number(employee.NET_SALARY || 0);

      // Validate required fields
      if (!employee.ACCOUNT_NUMBER || employee.ACCOUNT_NUMBER === '-' || employee.ACCOUNT_NUMBER === 'N/A') {
        throw new Error('Missing or invalid account number');
      }

      if (salary <= 0) {
        throw new Error('Salary must be greater than zero');
      }

      const payload = {
        p_Tran_ID: 0,
        p_Bank_Name: employee.BANK_NAME || '',
        p_Destination_Bank: employee.BANK_CODE || employee.BANK_NAME || '',
        p_Branch_Name: employee.BRANCH_NAME || '',
        p_Destination_Br: employee.BRANCH_CODE || '',
        p_Branch_Swift_Code: employee.SWIFT_CODE || '',
        p_Destination_Account: employee.ACCOUNT_NUMBER || '',
        p_Destination_Account_Name: employee.ACCOUNT_NAME || employee.REPORT_NAME || '',
        p_TRN_Code: '',
        p_Return_Code: '',
        p_Cr_Dr_Code: 'C',
        p_Amount: Math.abs(salary),
        p_Amount_Decimal: Math.abs(salary),
        p_Particulars: employee.SERVICE_NO || '',
        p_Reference: `Salary_${periodId}_${employee.SERVICE_NO || 'EMP'}`,
        p_Value_Date: '',
        p_Security_Field: '',
        p_Filler: '@',
        p_NIC_Number: employee.NIC_NO || employee.NIC || '',
        p_Created_By: getLoggedInServiceNo() || 'admin',
        p_Originating_BankCode: '',
        p_Originating_BranchCode: '',
      };

      console.log('[generateBankReport] Sending payload:', payload);

      const response = await payRollService.AddBankReport(payload);

      // Check response status
      const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(response?.data?.Message || response?.Message || 'Failed to generate bank report');
      }

      return {
        serviceNo: employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown',
        success: true,
        response: response.data,
      };
    } catch (error) {
      const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';
      console.error(`[generateBankReport] Failed for ${serviceNo}:`, error);
      return rejectWithValue({
        serviceNo,
        error: error.message || 'Failed to generate bank report',
      });
    }
  }
);

export const generateMultipleBankReports = createAsyncThunk(
  'payroll/generateMultipleBankReports',
  async ({ employees, periodId, selectedDate }, { dispatch, rejectWithValue }) => {
    try {
      const results = {
        success: [],
        failed: [],
        skipped: [],
        statuses: {},
      };

      // Validate each employee first
      const validEmployees = employees.filter(employee => {
        const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';
        const errors = [];

        if (!employee.BANK_NAME) errors.push('Bank Name');
        const accountNumber = employee.ACCOUNT_NUMBER || '';
        if (!accountNumber || accountNumber === '-' || accountNumber === 'N/A') {
          errors.push('Valid Account Number');
        }
        if (!employee.BRANCH_CODE) errors.push('Branch Code');
        const salary = Number(employee.NET_SALARY || 0);
        if (salary === 0) errors.push('Non-zero Salary');

        if (errors.length) {
          results.skipped.push({ serviceNo, reason: errors.join(', ') });
          results.statuses[serviceNo] = { status: 'skipped', reason: errors.join(', ') };
          return false;
        }
        return true;
      });

      if (!validEmployees.length) {
        return rejectWithValue({
          message: 'No valid employees found.',
          results,
        });
      }

      // Process each valid employee
      for (const employee of validEmployees) {
        const serviceNo = employee.SERVICE_NO || employee.EMPLOYEE_ID || 'Unknown';

        try {
          results.statuses[serviceNo] = { status: 'processing' };

          const result = await dispatch(generateBankReport({
            employee,
            periodId,
          })).unwrap();

          results.success.push(serviceNo);
          results.statuses[serviceNo] = { status: 'success' };
        } catch (error) {
          const errorMsg = error?.error || error?.message || 'Unknown error';
          results.failed.push({ serviceNo, error: errorMsg });
          results.statuses[serviceNo] = { status: 'failed', reason: errorMsg };
        }
      }

      // Refresh bank reports after generation
      await dispatch(fetchBankReportsByDate(selectedDate));

      return results;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to generate bank reports.');
    }
  }
);

export const fetchPayrollHeadersByPeriod = createAsyncThunk(
  'payroll/fetchPayrollHeadersByPeriod',
  async (periodId, { rejectWithValue }) => {
    try {
      const response = await payRollService.getPayrollHeadersByPeriod(periodId);

      const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(response?.data?.Message || "Failed to retrieve payroll headers.");
      }

      return response?.data?.ResultSet || response?.ResultSet || [];
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load payroll headers.");
    }
  }
)

// Fetch all entities (existing)
export const fetchPayrollEntityList = createAsyncThunk(
  'payroll/fetchEntityList',
  async (entityKey, { rejectWithValue }) => {
    try {
      let list = [];
      if (entityKey === 'payrollPeriods') {
        const response = await payRollService.GetPayRollPeriodList();
        list = (response.data?.ResultSet || []).map((item) => ({
          id: item.HPP_PAYROLL_PERIOD_ID,
          code: item.HPP_PERIOD_CODE,
          name: item.HPP_PERIOD_NAME,
          year: item.HPP_YEAR,
          month: item.HPP_MONTH,

          frequency: payFrequencyMap[item.HPP_PAY_FREQUENCY] ?? item.HPP_PAY_FREQUENCY,

          startDate: item.HPP_PAYROLL_START_DATE?.split(' ')[0],
          endDate: item.HPP_PAYROLL_END_DATE,
          attendanceStartDate: item.HPP_ATTENDANCE_START_DATE?.split(' ')[0],
          attendanceEndDate: item.HPP_ATTENDANCE_END_DATE,
          otStartDate: item.HPP_OT_START_DATE?.split(' ')[0],
          otEndDate: item.HPP_OT_END_DATE,
          payDate: item.HPP_PAYMENT_DATE?.split(' ')[0],
          status: item.HPP_STATUS === 'A' ? 'Active' : 'Inactive',
          isLocked: item.HPP_IS_LOCKED === 'True',
          glPosted: item.HPP_GL_POSTED === 'True',
          bankTransferGenerated: item.HPP_BANK_TRANSFER_GENERATED === 'True',
          isActive: item.HPP_IS_ACTIVE === 'True',
          remarks: item.HPP_REMARKS,
        }));
      } else if (entityKey === 'payrollComponents') {
        const response = await payRollService.GetPayRollComponentList();
        list = (response.data?.ResultSet || []).map((item) => ({
          id: item.HPC_COMPONENT_ID,
          code: item.HPC_COMPONENT_CODE,
          name: item.HPC_COMPONENT_NAME,
          type: componentTypeMap[item.HPC_COMPONENT_TYPE] ?? item.HPC_COMPONENT_TYPE,
          calcMethod: calculationMethodMap[item.HPC_CALCULATION_METHOD] ?? item.HPC_CALCULATION_METHOD,
          defaultAmount: Number(item.HPC_DEFAULT_AMOUNT || 0),
          defaultPercentage: Number(item.HPC_DEFAULT_PERCENTAGE || 0),
          earningCategory: earningCategoryMap[item.HPC_EARNING_CATEGORY] ?? (item.HPC_EARNING_CATEGORY || 'None'),
          rawEarningCategory: item.HPC_EARNING_CATEGORY || '',
          basic: item.HPC_IS_BASIC === 'True',
          taxable: item.HPC_IS_TAXABLE === 'True',
          epf: item.HPC_IS_EPF === 'True',
          etf: item.HPC_IS_ETF === 'True',
          otPayable: item.HPC_IS_OT === 'True',
          isNoPay: item.HPC_IS_NOPAY === 'True',
          printOnPayslip: item.HPC_PRINT_ON_PAYSLIP === 'True',
          glAccountCode: item.HPC_GL_ACCOUNT_CODE,
          sortOrder: Number(item.HPC_SORT_ORDER || 0),
          status: item.HPC_IS_ACTIVE === 'True' ? 'Active' : 'Inactive',
          remarks: item.HPC_REMARKS,

          salarySlipDescription: item.HPC_SALARY_SLIP_DESCRIPTION || '',
          description: item.HPC_DESCRIPTION || '',
          accountNo: item.HPC_ACCOUNT_NUMBER || '',
          isBatch: item.HPC_IS_BATCH === 'True' || item.HPC_IS_BATCH === '1' || item.HPC_IS_BATCH === 1,
        }));
      }
      else if (entityKey === "employeeSalary") {
        const response = await payRollService.GetEmployeeSalaryList();

        list = (response.data.ResultSet || []).map((item) => ({
          id: item.HES_EMPLOYEE_SALARY_ID,

          employeeId: item.HES_EMPLOYEE_ID,
          empNo: item.HED_SERVICE_NO,
          name: item.HED_REPORT_NAME,

          payrollPeriodId: item.HES_PAYROLL_PERIOD_ID,
          salaryReference: item.HES_SALARY_REFERENCE,

          effectiveDate: item.HES_EFFECTIVE_DATE?.split(" ")[0],
          endDate: item.HES_END_DATE?.split(" ")[0],

          payFrequency: payFrequencyMap[item.HES_PAY_FREQUENCY],

          basic: Number(item.HES_BASIC_SALARY || 0),
          grossSalary: Number(item.HES_GROSS_SALARY || 0),

          workingDays: Number(item.HES_STANDARD_WORKING_DAYS || 0),
          workingHours: Number(item.HES_STANDARD_WORKING_HOURS || 0),

          hourlyRate: Number(item.HES_HOURLY_RATE || 0),
          dailyRate: Number(item.HES_DAILY_RATE || 0),

          isCurrent: item.HES_IS_CURRENT === "True",
          isActive: item.HES_IS_ACTIVE === "True",

          approvedBy: item.HES_APPROVED_BY,

          remarks: item.HES_REMARKS,

          status:
            item.HES_IS_CURRENT === "True"
              ? "Current"
              : "Inactive",
        }));
      }
      else if (entityKey === "employeeSalaryComponents") {
        const response = await payRollService.GetEmployeeSalaryComponentList();

        list = (response.data.ResultSet || []).map((item) => ({
          id: item.HSC_EMPLOYEE_SALARY_COMPONENT_ID,

          employeeSalaryId: item.HSC_EMPLOYEE_SALARY_ID,
          employeeId: item.HES_EMPLOYEE_ID,

          empNo: item.HED_SERVICE_NO,
          name: item.EMPLOYEE_NAME,

          componentId: item.HSC_COMPONENT_ID,

          amount: Number(item.HSC_AMOUNT || 0),
          percentage: Number(item.HSC_PERCENTAGE || 0),

          effectiveDate: item.HSC_EFFECTIVE_DATE?.split(" ")[0],
          endDate: item.HSC_END_DATE?.split(" ")[0],

          isActive: item.HSC_IS_ACTIVE === "True",

          remarks: item.HSC_REMARKS,
        }));
      }
      else if (entityKey === "batchManagement") {
        const response = await payRollService.GetPayRollBatchList();

        list = (response.data.ResultSet || []).map((item) => ({
          id: item.HPB_BATCH_ID,

          batchNo: item.HPB_BATCH_NO,
          name: item.HPB_BATCH_NAME,

          periodId: item.HPB_PAYROLL_PERIOD_ID,
          componentId: item.HPB_COMPONENT_ID,

          calculationMethod: calculationMethodMap[item.HPB_CALCULATION_METHOD] ??
            item.HPB_CALCULATION_METHOD,

          amount: Number(item.HPB_AMOUNT || 0),
          percentage: Number(item.HPB_PERCENTAGE || 0),

          effectiveDate: item.HPB_EFFECTIVE_DATE?.split(" ")[0],
          description: item.HPB_DESCRIPTION,

          status: batchStatusMap[item.HPB_STATUS] ??
            item.HPB_STATUS,

          approvedBy: item.HPB_APPROVED_BY,
          postedBy: item.HPB_POSTED_BY,
          createdBy: item.HPB_CREATED_BY,
          updatedBy: item.HPB_UPDATED_BY,

          isActive: item.HPB_IS_ACTIVE === "True",
          remarks: item.HPB_REMARKS,
        }))
      }
      else if (entityKey === "overtimeEntry") {
        const response = await payRollService.GetOvertimeList();

        list = (response.data.ResultSet || []).map((item) => {
          const isApproved = item.HOT_IS_APPROVED === "True";

          return {
            id: item.HOT_OVERTIME_ID,

            employeeId: item.HOT_EMPLOYEE_ID,
            // empNo: item.HOT_OVERTIME_ID,
            // name: item.HOT_OVERTIME_ID,

            payrollPeriodId: item.HOT_PAYROLL_PERIOD_ID,
            payrollId: item.HOT_PAYROLL_ID,

            date: item.HOT_OT_DATE?.split(" ")[0],
            otType: item.HOT_OT_TYPE,
            startTime: item.HOT_START_TIME,
            endTime: item.HOT_END_TIME,

            hours: Number(item.HOT_TOTAL_HOURS),
            rate: Number(item.HOT_OT_RATE),
            amount: Number(item.HOT_OT_AMOUNT),

            isApproved,
            approvedBy: item.HOT_APPROVED_BY,
            createdBy: item.HOT_CREATED_BY,
            isActive: item.HOT_IS_ACTIVE,

            status: isApproved ? "Approved" : "Pending",
          }
        })
      }
      else if (entityKey === "loanManagement") {
        const response = await payRollService.GetLoanList();

        list = (response.data.ResultSet || []).map(item => ({
          id: item.HLM_LOAN_ID,

          employeeId: item.HLM_EMPLOYEE_ID,
          empNo: item.HED_SERVICE_NO,
          name: item.HED_REPORT_NAME,

          loanNo: item.HLM_LOAN_NO,
          loanType: item.HLM_LOAN_TYPE,
          loanTypeId: item.HLM_LOAN_TYPE_ID ? String(item.HLM_LOAN_TYPE_ID) : "",
          loanDescription: item.HLM_LOAN_DESCRIPTION,

          loanDate: item.HLM_LOAN_DATE?.split(" ")[0],
          approvedDate: item.HLM_APPROVED_DATE?.split(" ")[0],

          amount: Number(item.HLM_LOAN_AMOUNT || 0),

          interestRate: Number(item.HLM_INTEREST_RATE || 0),

          totalInterest: Number(item.HLM_TOTAL_INTEREST || 0),

          totalAmount: Number(item.HLM_TOTAL_AMOUNT || 0),

          installments: Number(item.HLM_NO_OF_INSTALLMENTS || 0),

          installmentAmount: Number(item.HLM_INSTALLMENT_AMOUNT || 0),

          startPeriodId: item.HLM_START_PERIOD_ID,
          endPeriodId: item.HLM_END_PERIOD_ID,

          balance: Number(item.HLM_BALANCE_AMOUNT || 0),

          status: item.HLM_STATUS === "P" ? "Not Paid" : "Paid",
          // Raw code (P, A, …) — sent back unchanged when the loan is updated.
          statusCode: item.HLM_STATUS,

          approvedBy: item.HLM_APPROVED_BY,
          createdBy: item.HLM_CREATED_BY,
          createdDate: item.HLM_CREATED_DATE,
          updatedBy: item.HLM_UPDATED_BY,
          updatedDate: item.HLM_UPDATED_DATE,
          isActive: item.HLM_IS_ACTIVE,
          remarks: item.HLM_REMARKS,
        }))
      } else if (entityKey === "loanInstallments") {
        const response = await payRollService.GetLoanList();

        list = (response.data.ResultSet || []).map(item => ({
          id: item.HLM_LOAN_ID,

          employeeId: item.HLM_EMPLOYEE_ID,
          empNo: item.HED_SERVICE_NO,
          name: item.HED_REPORT_NAME,

          loanNo: item.HLM_LOAN_NO,
          loanType: item.HLM_LOAN_TYPE,
          loanDescription: item.HLM_LOAN_DESCRIPTION,

          loanDate: item.HLM_LOAN_DATE?.split(" ")[0],
          approvedDate: item.HLM_APPROVED_DATE?.split(" ")[0],

          amount: Number(item.HLM_LOAN_AMOUNT || 0),

          interestRate: Number(item.HLM_INTEREST_RATE || 0),

          totalInterest: Number(item.HLM_TOTAL_INTEREST || 0),

          totalAmount: Number(item.HLM_TOTAL_AMOUNT || 0),

          installments: Number(item.HLM_NO_OF_INSTALLMENTS || 0),

          installmentAmount: Number(item.HLM_INSTALLMENT_AMOUNT || 0),

          startPeriodId: item.HLM_START_PERIOD_ID,
          endPeriodId: item.HLM_END_PERIOD_ID,

          balance: Number(item.HLM_BALANCE_AMOUNT || 0),

          status: item.HLM_STATUS === "P" ? "Pending" : "Other",

          approvedBy: item.HLM_APPROVED_BY,
          createdBy: item.HLM_CREATED_BY,
          createdDate: item.HLM_CREATED_DATE,
          updatedBy: item.HLM_UPDATED_BY,
          updatedDate: item.HLM_UPDATED_DATE,
          isActive: item.HLM_IS_ACTIVE,
          remarks: item.HLM_REMARKS,
        }))
      }
      else {

        list = [];
      }
      return { entityKey, list };
    } catch (error) {

      return rejectWithValue({ entityKey, msg: error.message || error.toString() });
    }
  }
);

export const fetchBankReportDetailsByDate = createAsyncThunk(
  'payroll/fetchBankReportDetailsByDate',
  async (createdDate, { rejectWithValue }) => {
    try {
      const response = await payRollService.GetBankReportDetailsByDate(createdDate);

      if (!response) {
        throw new Error('No response received from server.');
      }

      const statusCode = response?.data?.StatusCode || response?.StatusCode;
      if (statusCode !== 200) {
        throw new Error(response?.data?.Message || 'Failed to retrieve bank report details.');
      }

      const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

      if (!Array.isArray(resultSet)) {
        throw new Error('Invalid data format received.');
      }

      if (resultSet.length === 0) {
        return rejectWithValue('No bank reports found for this date.');
      }

      const hasRealData = resultSet.some(
        (item) => item.HBR_Bank_Name || item.HBR_Destination_Account || item.HBR_Amount
      );

      if (!hasRealData) {
        return rejectWithValue('No valid data found for this date.');
      }

      const formattedItems = resultSet.map((item) => ({
        id: item.HBR_Tran_ID || '0',
        bankName: item.HBR_Bank_Name || '',
        destinationBank: item.HBR_Destination_Bank || '',
        branchName: item.HBR_Branch_Name || '',
        destinationBr: item.HBR_Destination_Br || '',
        branchSwiftCode: item.HBR_Branch_Swift_Code || '',
        destinationAccount: item.HBR_Destination_Account || '',
        destinationAccountName: item.HBR_Destination_Account_Name || '',
        trnCode: item.HBR_TRN_Code || '0',
        returnCode: item.HBR_Return_Code || '0',
        crDrCode: item.HBR_Cr_Dr_Code || '0',
        returnDate: item.HBR_Return_Date || '',
        amount: item.HBR_Amount || '',
        amountDecimal: item.HBR_Amount_Decimal || '',
        currencyCode: item.HBR_Currency_Code || 'SLR',
        originatingAccount: item.HBR_Originating_Account || '',
        originatingAccountName: item.HBR_Originating_Account_Name || '',
        particulars: item.HBR_Particulars || '',
        reference: item.HBR_Reference || '',
        valueDate: item.HBR_Value_Date || '0',
        securityField: item.HBR_Security_Field || '0',
        filler: item.HBR_Filler || '@',
        nicNumber: item.HBR_NIC_Number || '',
        
        // ── year/month for client-side filtering ──
        year: item.HBR_Year != null && item.HBR_Year !== '' ? Number(item.HBR_Year) : null,
        month: item.HBR_Month != null && item.HBR_Month !== '' ? Number(item.HBR_Month) : null,
      }));

      return formattedItems;
    } catch (error) {
      return rejectWithValue(error.message || error.toString());
    }
  }
);

export const markBankReportStatus = createAsyncThunk(
  'payroll/markBankReportStatus',
  async ({ year, month, stage }, { rejectWithValue }) => {
    try {
      if (!year || !month || !stage) {
        return rejectWithValue('Year, month, and stage are required.');
      }

      let response;
      if (stage === 'prepared') {
        response = await payRollService.MarkBankReportPrepared(year, month);
      } else if (stage === 'authorized') {
        response = await payRollService.MarkBankReportAuthorized(year, month);
      } else if (stage === 'approved') {
        response = await payRollService.MarkBankReportApproved(year, month);
      } else {
        return rejectWithValue(`Unknown stage: ${stage}`);
      }

      const statusCode =
        response?.data?.StatusCode ??
        response?.StatusCode ??
        response?.status;

      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(
          response?.data?.Message ||
          response?.data?.Result ||
          `Failed to mark report as ${stage}.`
        );
      }

      return {
        year,
        month,
        stage,
        message: response?.data?.Result || response?.data?.Message || null,
      };
    } catch (error) {
      return rejectWithValue(error.message || `Failed to mark report as ${stage}.`);
    }
  }
);

export const fetchSalaryComponentSummary = createAsyncThunk(
  'payroll/fetchSalaryComponentSummary',
  async (periodId, { rejectWithValue }) => {
    try {

      const response = await payRollService.GetSalaryComponentSummary(Number(periodId) || 0);

      const statusCode = response?.data?.StatusCode ?? response?.StatusCode ?? response?.status;
      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(response?.data?.Message || 'Failed to retrieve salary component summary.');
      }

      const resultSet = response?.data?.ResultSet || response?.ResultSet || [];

      if (!Array.isArray(resultSet)) {
        throw new Error('Invalid data format received.');
      }

      return {
        employees: resultSet, // full, unfiltered raw set
        count: resultSet.length,
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load salary component summary.');
    }
  }
);

export const fetchCurrentPeriodId = createAsyncThunk(
  'payroll/fetchCurrentPeriodId',
  async (_, { rejectWithValue }) => {
    try {
      const periodId = await payRollService.GetCurrentPeriodId();
      if (!periodId) {

        return rejectWithValue('No current payroll period found.');

      }
      return periodId;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch current period ID.');

    }
  }
);

const emptyEntity = { list: [], loading: false, saving: false, msg: null };

const payrollSlice = createSlice({
  name: 'payroll',
  initialState: {
    entities: {},

    payrollHeaders: {
      data: [],
      loading: false,
      error: null,
    },

    // Payroll Text specific state
    payrollText: {
      periodId: '',
      currentPeriodId: null,
      selectedDate: '',
      payrollDetails: [],
      bankReports: [],
      loading: false,
      generating: false,
      generationStatus: {},
      error: null,
      success: null,
    },

    // ── validation workflow ──
    validation: {
      prepared: false,
      authorized: false,
      approved: false,
      submittedStages: [],
      stageLoading: null,
      stageError: null,
    },

    salaryComponentSummary: {
      employees: [],
      loading: false,
      error: null,
    },

    bankReport: {
      items: [],
      loading: false,
      error: null,
    },
  },

  reducers: {
    saveEntity: (state, action) => {
      const { entityKey, record, isEdit } = action.payload;
      const entity = state.entities[entityKey] || emptyEntity;
      const list = isEdit
        ? entity.list.map((row) => (row.id === record.id ? { ...row, ...record } : row))
        : [{ ...record, id: record.id || `${entityKey}-${Date.now()}` }, ...entity.list];

      state.entities[entityKey] = {
        ...entity,
        saving: false,
        list,
      };
    },
    removeEntity: (state, action) => {
      const { entityKey, id } = action.payload;
      const entity = state.entities[entityKey] || emptyEntity;
      state.entities[entityKey] = {
        ...entity,
        list: entity.list.filter((row) => row.id !== id),
      };
    },
    // Payroll Text specific reducers
    setPayrollPeriodId: (state, action) => {
      state.payrollText.periodId = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.payrollText.selectedDate = action.payload;
    },
    clearPayrollTextError: (state) => {
      state.payrollText.error = null;
      state.payrollText.success = null;
    },
    resetPayrollText: (state) => {
      state.payrollText = {
        periodId: '',
        currentPeriodId: null,
        selectedDate: '',
        payrollDetails: [],
        bankReports: [],
        loading: false,
        generating: false,
        generationStatus: {},
        error: null,
        success: null,
      };
    },
    clearGenerationStatus: (state) => {
      state.payrollText.generationStatus = {};
    },

    resetValidationState: (state) => {
      state.payrollText.validation = {
        prepared: false,
        authorized: false,
        approved: false,
        submittedStages: [],
        stageLoading: null,
        stageError: null,
      };
    },
    clearStageError: (state) => {
      state.payrollText.validation.stageError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Payroll Details by Period
      .addCase(fetchPayrollDetailsByPeriod.pending, (state) => {
        state.payrollText.loading = true;
        state.payrollText.error = null;
      })
      .addCase(fetchPayrollDetailsByPeriod.fulfilled, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.payrollDetails = action.payload.payrollDetails;
        state.payrollText.periodId = action.payload.periodId;
        state.payrollText.error = null;
        state.payrollText.success = `${action.payload.count} payroll record(s) loaded.`;
      })
      .addCase(fetchPayrollDetailsByPeriod.rejected, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.payrollDetails = [];
        state.payrollText.error = action.payload || 'Failed to load payroll details.';
        state.payrollText.success = null;
      })

      // Fetch Bank Reports by Date
      .addCase(fetchBankReportsByDate.pending, (state) => {
        state.payrollText.loading = true;
        state.payrollText.error = null;
      })
      .addCase(fetchBankReportsByDate.fulfilled, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.bankReports = action.payload.items;
        state.payrollText.selectedDate = action.payload.selectedDate;
        state.payrollText.error = null;
      })
      .addCase(fetchBankReportsByDate.rejected, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.bankReports = [];
        state.payrollText.error = action.payload || 'Failed to load bank reports.';
      })

      // Generate Multiple Bank Reports
      .addCase(generateMultipleBankReports.pending, (state) => {
        state.payrollText.generating = true;
        state.payrollText.error = null;
        state.payrollText.generationStatus = {};
      })
      .addCase(generateMultipleBankReports.fulfilled, (state, action) => {
        state.payrollText.generating = false;
        state.payrollText.generationStatus = action.payload.statuses || {};

        const { success, failed, skipped } = action.payload;
        let message = `Generated ${success.length} bank report(s).`;
        if (failed.length > 0) message += ` ${failed.length} failed.`;
        if (skipped.length > 0) message += ` ${skipped.length} skipped.`;
        state.payrollText.success = message;

        if (failed.length > 0) {
          state.payrollText.error = `Failed for: ${failed.slice(0, 3).map(f => f.serviceNo).join(', ')}${failed.length > 3 ? `... and ${failed.length - 3} more` : ''}`;
        }
      })
      .addCase(generateMultipleBankReports.rejected, (state, action) => {
        state.payrollText.generating = false;
        state.payrollText.error = action.payload?.message || 'Failed to generate bank reports.';
        if (action.payload?.results) {
          state.payrollText.generationStatus = action.payload.results.statuses || {};
        }
      })

      // Existing entity fetch
      .addCase(fetchPayrollEntityList.pending, (state, action) => {
        const entityKey = action.meta.arg;
        const entity = state.entities[entityKey] || emptyEntity;
        state.entities[entityKey] = { ...entity, loading: true, msg: null };
      })
      .addCase(fetchPayrollEntityList.fulfilled, (state, action) => {
        const { entityKey, list } = action.payload;
        const entity = state.entities[entityKey] || emptyEntity;
        state.entities[entityKey] = { ...entity, loading: false, saving: false, list };
      })
      .addCase(fetchPayrollEntityList.rejected, (state, action) => {
        const entityKey = action.payload?.entityKey || action.meta.arg;
        const entity = state.entities[entityKey] || emptyEntity;
        state.entities[entityKey] = { ...entity, loading: false, msg: action.payload?.msg || action.error.message };
      })

      // Bank Report Details (existing)
      .addCase(fetchBankReportDetailsByDate.pending, (state) => {
        state.bankReport.loading = true;
        state.bankReport.error = null;
      })
      .addCase(fetchBankReportDetailsByDate.fulfilled, (state, action) => {
        state.bankReport.loading = false;
        state.bankReport.items = action.payload;
        state.bankReport.error = null;
      })
      .addCase(fetchBankReportDetailsByDate.rejected, (state, action) => {
        state.bankReport.loading = false;
        state.bankReport.items = [];
        state.bankReport.error = action.payload || action.error.message;
      })

      // Fetch Current Period ID
      .addCase(fetchCurrentPeriodId.pending, (state) => {
        state.payrollText.loading = true;
        state.payrollText.error = null;
      })
      .addCase(fetchCurrentPeriodId.fulfilled, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.currentPeriodId = action.payload;
        state.payrollText.error = null;
      })
      .addCase(fetchCurrentPeriodId.rejected, (state, action) => {
        state.payrollText.loading = false;
        state.payrollText.currentPeriodId = null;
        state.payrollText.error = action.payload || 'Failed to fetch current period ID.';
      })

      // Salary Component Summary
      .addCase(fetchSalaryComponentSummary.pending, (state) => {
        state.salaryComponentSummary.loading = true;
        state.salaryComponentSummary.error = null;
      })
      .addCase(fetchSalaryComponentSummary.fulfilled, (state, action) => {
        state.salaryComponentSummary.loading = false;
        state.salaryComponentSummary.employees = action.payload.employees;
        state.salaryComponentSummary.error = null;
      })
      .addCase(fetchSalaryComponentSummary.rejected, (state, action) => {
        state.salaryComponentSummary.loading = false;
        state.salaryComponentSummary.employees = [];
        state.salaryComponentSummary.error = action.payload || 'Failed to load salary component summary.';
      })

      // Mark Bank Report Status (Prepared / Authorized / Approved)
      .addCase(markBankReportStatus.pending, (state, action) => {
        state.payrollText.validation.stageLoading = action.meta.arg.stage;
        state.payrollText.validation.stageError = null;
      })
      .addCase(markBankReportStatus.fulfilled, (state, action) => {
        const { stage } = action.payload;
        state.payrollText.validation.stageLoading = null;
        state.payrollText.validation[stage] = true;
        if (!state.payrollText.validation.submittedStages.includes(stage)) {
          state.payrollText.validation.submittedStages.push(stage);
        }
        state.payrollText.success = `Report marked as ${stage}.`;
      })
      .addCase(markBankReportStatus.rejected, (state, action) => {
        state.payrollText.validation.stageLoading = null;
        state.payrollText.validation.stageError =
          action.payload || `Failed to mark report.`;
      })

      // Payroll Headers By Period
      .addCase(fetchPayrollHeadersByPeriod.pending, (state) => {
        state.payrollHeaders.loading = true;
        state.payrollHeaders.error = null;
      })
      .addCase(fetchPayrollHeadersByPeriod.fulfilled, (state, action) => {
        state.payrollHeaders.loading = false;
        state.payrollHeaders.data = action.payload;
      })
      .addCase(fetchPayrollHeadersByPeriod.rejected, (state, action) => {
        state.payrollHeaders.loading = false;
        state.payrollHeaders.data = [];
        state.payrollHeaders.error = action.payload || 'Failed to load payroll headers.';
      })

      // Get Loans By Status
      .addCase(fetchLoanList.pending, (state) => {
        state.entities.loanManagement = {
          ...(state.entities.loanManagement || emptyEntity),
          loading: true,
          msg: null,
        };
      })
      .addCase(fetchLoanList.fulfilled, (state, action) => {
        state.entities.loanManagement = {
          ...(state.entities.loanManagement || emptyEntity),
          loading: false,
          list: action.payload,
          msg: null,
        };
      })
      .addCase(fetchLoanList.rejected, (state, action) => {
        state.entities.loanManagement = {
          ...(state.entities.loanManagement || emptyEntity),
          loading: false,
          msg: action.payload || "Failed to fetch loans.",
        };
      });
  },
});

export const {
  saveEntity,
  removeEntity,
  setPayrollPeriodId,
  setSelectedDate,
  clearPayrollTextError,
  resetPayrollText,
  clearGenerationStatus,
  resetValidationState,
  clearStageError,
} = payrollSlice.actions;

// Selectors for Payroll Text
export const selectPayrollTextState = (state) => state.payroll.payrollText;
export const selectPayrollDetails = (state) => state.payroll.payrollText.payrollDetails;
export const selectBankReports = (state) => state.payroll.payrollText.bankReports;
export const selectPayrollTextLoading = (state) => state.payroll.payrollText.loading;
export const selectPayrollTextGenerating = (state) => state.payroll.payrollText.generating;
export const selectPayrollTextError = (state) => state.payroll.payrollText.error;
export const selectPayrollTextSuccess = (state) => state.payroll.payrollText.success;
export const selectPayrollTextPeriodId = (state) => state.payroll.payrollText.periodId;
export const selectPayrollTextSelectedDate = (state) => state.payroll.payrollText.selectedDate;
export const selectGenerationStatus = (state) => state.payroll.payrollText.generationStatus;
export const selectCurrentPeriodId = (state) => state.payroll.payrollText.currentPeriodId;
export const selectPayrollHeaders = (state) => state.payroll.payrollHeaders;

// Existing selectors
export const selectEntities = (state) => state.payroll.entities;
export const selectEntity = (entityKey) => (state) => state.payroll.entities[entityKey] || emptyEntity;
export const selectBankReport = (state) => state.payroll.bankReport;

export const selectSalaryComponentSummary = (state) => state.payroll?.salaryComponentSummary?.employees || [];
export const selectSalarySummaryLoading = (state) => state.payroll?.salaryComponentSummary?.loading || false;
export const selectSalarySummaryError = (state) => state.payroll?.salaryComponentSummary?.error || null;

export const selectValidationState = (state) =>
  state.payroll?.payrollText?.validation || {
    prepared: false,
    authorized: false,
    approved: false,
    submittedStages: [],
    stageLoading: null,
    stageError: null,
  };

export default payrollSlice.reducer;




export const mapOvertimeRow = (item) => {
  const isApprovedRaw = pick(item, ["isApproved", "IsApproved", "OT_IS_APPROVED", "HOT_IS_APPROVED"], 0);
  const isApproved = isApprovedRaw === 1 || isApprovedRaw === "1" || isApprovedRaw === true || isApprovedRaw === "True";

  return {
    id: pick(item, ["overtimeId", "OvertimeId", "OT_OVERTIME_ID", "HOT_OVERTIME_ID", "OVERTIME_ID"]),

    employeeId: pick(item, ["employeeId", "EmployeeId", "OT_EMPLOYEE_ID", "HOT_EMPLOYEE_ID"]),
    empNo: pick(item, ["HED_SERVICE_NO", "empNo", "EmpNo"]),
    name: pick(item, ["HED_REPORT_NAME", "employeeName", "EmployeeName"]),

    payrollPeriodId: pick(item, ["payrollPeriodId", "PayrollPeriodId", "OT_PAYROLL_PERIOD_ID", "HOT_PAYROLL_PERIOD_ID"]),
    payrollId: pick(item, ["payrollId", "PayrollId", "OT_PAYROLL_ID", "HOT_PAYROLL_ID"]),

    date: formatDate(String(pick(item, ["otDate", "OtDate", "OT_DATE", "HOT_OT_DATE"], "") || "")),
    otType: pick(item, ["otType", "OtType", "OT_TYPE", "HOT_OT_TYPE"], "T"),
    startTime: pick(item, ["startTime", "StartTime", "OT_START_TIME", "HOT_START_TIME"], ""),
    endTime: pick(item, ["endTime", "EndTime", "OT_END_TIME", "HOT_END_TIME"], ""),

    hours: Number(pick(item, ["totalHours", "TotalHours", "OT_TOTAL_HOURS", "HOT_TOTAL_HOURS"], 0)),
    rate: Number(pick(item, ["otRate", "OtRate", "OT_RATE", "HOT_OT_RATE"], 0)),
    amount: Number(pick(item, ["otAmount", "OtAmount", "OT_AMOUNT", "HOT_OT_AMOUNT"], 0)),

    isApproved,
    approvedBy: pick(item, ["approvedBy", "ApprovedBy", "OT_APPROVED_BY", "HOT_APPROVED_BY"]),
    createdBy: pick(item, ["createdBy", "CreatedBy", "OT_CREATED_BY", "HOT_CREATED_BY"]),
    isActive: pick(item, ["isActive", "IsActive", "OT_IS_ACTIVE", "HOT_IS_ACTIVE"], 1),

    status: isApproved ? "Approved" : "Pending",
  };
};

// Loads a payroll entity's list into state.payroll.entities[entityKey].

export const getPayrollPreview = (payrollPeriodId, batchEmployees = []) => async (dispatch) => {
  let salaryRows = [];
  try {
    const employeeSalaryResponse = await payRollService.GetEmployeeSalaryList();
    salaryRows = employeeSalaryResponse.data?.ResultSet || [];
  } catch (err) {
    console.warn("GetEmployeeSalaryList failed, falling back to mock data preview", err);
    // return PAYROLL_MOCK_DATA.payrollPreview || [];
    throw err;
  }

  // Employees who have salary configured for the selected payroll period
  // let employees = salaryRows.filter(
  //   (item) => String(item.HES_PAYROLL_PERIOD_ID) === String(payrollPeriodId) &&
  //   item.HES_IS_ACTIVE === "True" && item.HES_IS_CURRENT === "True"
  // );

  let employees = salaryRows.filter(
    (item) => item.HES_IS_ACTIVE === "True" && item.HES_IS_CURRENT === "True"
  )

  if (batchEmployees.length > 0) {
    const batchServiceNos = new Set(
      batchEmployees.map((emp) => String(emp.empNo))
    );

    employees = employees.filter((item) =>
      batchServiceNos.has(String(item.HED_SERVICE_NO))
    );
  }

  if (employees.length === 0) {
    // return PAYROLL_MOCK_DATA.payrollPreview || [];
    return [];
  }

  // Call PayrollPreview for every employee
  const previewResults = await Promise.all(
    employees.map(async (employee) => {
      try {
        const response = await payRollService.GetPreviewPayroll(
          payrollPeriodId,
          employee.HES_EMPLOYEE_ID
        );

        const result = response.data?.ResultSet;

        const summary = result?.Summary?.[0];

        if (!summary) {
          return null;
        }

        const details = result?.Details || [];

        const totalEarnings = Number(summary.TOTAL_EARNINGS || 0);
        const totalDeductions = Number(summary.TOTAL_DEDUCTIONS || 0);
        const epf = Number(summary.EMPLOYEE_EPF || 0);

        // const grossPay = totalEarnings - (totalDeductions - epf);
        // const grossDeductions = totalDeductions - epf;

        return {
          id: employee.HES_EMPLOYEE_ID,

          employeeId: employee.HES_EMPLOYEE_ID,
          empNo: summary.SERVICE_NO || employee.HED_SERVICE_NO,
          name: summary.EMPLOYEE_NAME || employee.HED_REPORT_NAME,

          payrollNo: summary.PAYROLL_NO,
          payDate: formatDate(summary.PAY_DATE),

          workingDays: Number(summary.WORKING_DAYS || 0),
          presentDays: Number(summary.PRESENT_DAYS || 0),
          noPayDays: Number(summary.NO_PAY_DAYS || 0),
          otHours: Number(summary.OT_HOURS || 0),

          // gross: grossPay,
          gross: Number(summary.GROSS_EARNINGS ?? totalEarnings),
          totalEarnings: totalEarnings,
          // totalDeductions: grossDeductions,
          totalDeductions: totalDeductions,

          epf: epf,
          employerEpf: Number(summary.EMPLOYER_EPF || 0),
          employerEtf: Number(summary.EMPLOYER_ETF || 0),

          net: Number(summary.NET_SALARY || 0),

          // Keep the calculation details available for a future expandable employee preview
          details: details.map((detail) => ({
            employeeId: detail.EMPLOYEE_ID,
            componentId: detail.COMPONENT_ID,
            componentCode: detail.COMPONENT_CODE,
            componentName: detail.COMPONENT_NAME,
            componentType: detail.COMPONENT_TYPE,
            description: detail.DESCRIPTION,
            quantity: detail.QUANTITY === ""
              ? null
              : Number(detail.QUANTITY || 0),
            percentage: detail.PERCENTAGE === ""
              ? null
              : Number(detail.PERCENTAGE || 0),
            amount: Number(detail.AMOUNT || 0),
          })),
        };
      } catch (error) {
        console.error(`Payroll preview failed for employee ${employee.HES_EMPLOYEE_ID}`, error);
        return null;
      }
    })
  );

  return previewResults.filter(Boolean);
}

export const calculatePayroll = (payrollPeriodId, createdBy = "system") => async (dispatch) => {
  try {
    const response = await payRollService.CalculatePayroll(payrollPeriodId, createdBy);
    return response;
  } catch (error) {
    console.error("Payroll calculation failed: ", error);
    throw error;
  }
}

export const getPayrollDetailsBySno = (payrollPeriodId, serviceNo) => async () => {
  const response = await payRollService.GetPayrollDetailsBySno(
    payrollPeriodId,
    serviceNo
  );

  const result = response.data?.ResultSet;

  if (!result) {
    throw new Error("The payroll for this period has not been generated.");
  }

  return result;
}


export const getPayrollBatchEmployees = (batchId) => async () => {
  if (!batchId) {
    return [];
  }

  const response = await payRollService.BatchEmployee.GetPayRollEmpByBatchId(batchId);
  const list = response.data?.ResultSet || [];

  return list
    .filter((item) => item.HPBE_IS_ACTIVE === "True")
    .map((item) => ({
      employeeId: pick(item, ["HED_EMPLOYEE_ID", "HPBE_EMPLOYEE_ID", "employeeId"]),
      empNo: item.HED_SERVICE_NO,
      name: item.HED_REPORT_NAME,
      batchEmployeeId: item.HPBE_BATCH_EMPLOYEE_ID,
    }))
    .filter((emp) => emp.empNo);
};

export const savePayrollEntity = (entityKey, record, isEdit = false) => async (
  dispatch
) => {
  dispatch({ type: PAYROLL_SAVE_REQUEST, payload: { entityKey } });

  const userId = getLoggedInServiceNo();

  try {

    if (entityKey === "payrollPeriods") {
      if (isEdit) {
        await payRollService.UpdatePayRollPeriod({
          payrollPeriodId: record.id,

          ...(record.code !== undefined && record.code !== null && {
            periodCode: record.code,
          }),

          ...(record.name !== undefined && record.name !== null && {
            periodName: record.name,
          }),

          ...(record.year !== undefined && record.year !== null && {
            year: record.year,
          }),

          ...(record.month !== undefined && record.month !== null && {
            month: record.month,
          }),

          ...(record.startDate !== undefined && record.startDate !== null && {
            payrollStartDate: record.startDate,
          }),

          ...(record.endDate !== undefined && record.endDate !== null && {
            payrollEndDate: record.endDate,
          }),

          ...(record.attendanceStartDate !== undefined && record.attendanceStartDate !== null && {
            attendanceStartDate: record.attendanceStartDate,
          }),

          ...(record.attendanceEndDate !== undefined && record.attendanceEndDate !== null && {
            attendanceEndDate: record.attendanceEndDate,
          }),

          ...(record.otStartDate !== undefined && record.otStartDate !== null && {
            otStartDate: record.otStartDate,
          }),

          ...(record.otEndDate !== undefined && record.otEndDate !== null && {
            otEndDate: record.otEndDate,
          }),

          ...(record.payDate !== undefined && record.payDate !== null && {
            paymentDate: record.payDate,
          }),

          ...(record.periodType !== undefined && record.periodType !== null && {
            payFrequency: record.periodType,
          }),

          ...(record.status !== undefined && record.status !== null && {
            status: record.status,
          }),

          ...(record.isLocked !== undefined && record.isLocked !== null && {
            isLocked: record.isLocked,
          }),

          ...(record.glPosted !== undefined && record.glPosted !== null && {
            glPosted: record.glPosted,
          }),

          ...(record.bankTransferGenerated !== undefined && record.bankTransferGenerated !== null && {
            bankTransferGenerated: record.bankTransferGenerated,
          }),

          updatedBy: userId,

          ...(record.isActive !== undefined && record.isActive !== null && {
            isActive: record.isActive,
          }),

          ...(record.remarks !== undefined && record.remarks !== null && {
            remarks: record.remarks,
          }),
        })
      } else {
        await payRollService.AddPayRollPeriod({
          periodCode: record.code,
          periodName: record.name,
          year: record.year,
          month: record.month,
          payFrequency: record.periodType,
          payrollStartDate: record.startDate,
          payrollEndDate: record.endDate,
          attendanceStartDate: record.attendanceStartDate,
          attendanceEndDate: record.attendanceEndDate,
          otStartDate: record.otStartDate,
          otEndDate: record.otEndDate,
          paymentDate: record.payDate,

          status: record.status ?? "A",
          isLocked: record.isLocked ?? "",
          glPosted: record.glPosted ?? "",
          bankTransferGenerated: record.bankTransferGenerated ?? "",
          createdBy: record.createdBy ?? userId,
          isActive: record.isActive ?? "",
          remarks: record.remarks ?? "",
        });
      }

      await dispatch(fetchPayrollEntityList("payrollPeriods"));

      return;
    }

    if (entityKey === "batchManagement") {
      if (isEdit) {
        await payRollService.UpdatePayRollBatch({
          batchId: record.batchId,

          ...(record.batchNo !== undefined && record.batchNo !== null && {
            batchNo: record.batchNo,
          }),

          ...(record.name !== undefined && record.name !== null && {
            batchName: record.name,
          }),

          ...(record.periodId !== undefined && record.periodId !== null && {
            payrollPeriodId: record.periodId,
          }),

          ...(record.componentId !== undefined && record.componentId !== null && {
            componentId: record.componentId,
          }),

          ...(record.calculationMethod !== undefined &&
            record.calculationMethod !== null && {
            calculationMethod: record.calculationMethod,
          }),

          ...(record.amount !== undefined && record.amount !== null && {
            amount: record.amount,
          }),

          ...(record.percentage !== undefined && record.percentage !== null && {
            percentage: record.percentage,
          }),

          ...(record.effectiveDate !== undefined &&
            record.effectiveDate !== null && {
            effectiveDate: record.effectiveDate,
          }),

          ...(record.description !== undefined &&
            record.description !== null && {
            description: record.description,
          }),

          ...(record.status !== undefined && record.status !== null && {
            status: record.status,
          }),

          ...(record.approvedBy !== undefined && record.approvedBy !== null && {
            approvedBy: record.approvedBy,
          }),

          ...(record.postedBy !== undefined && record.postedBy !== null && {
            postedBy: record.postedBy,
          }),

          updatedBy: userId,

          ...(record.isActive !== undefined && record.isActive !== null && {
            isActive: record.isActive,
          }),

          ...(record.remarks !== undefined && record.remarks !== null && {
            remarks: record.remarks,
          }),
        });
      } else {
        await payRollService.AddPayRollBatch({
          batchId: record.id ?? 0,
          batchNo: record.batchNo,
          batchName: record.name,
          payrollPeriodId: record.periodId,
          componentId: record.componentId,

          calculationMethod: record.calculationMethod,

          amount: record.amount,
          percentage: record.percentage,

          effectiveDate: record.effectiveDate,
          description: record.description,

          status: record.status,
          approvedBy: record.approvedBy ?? userId,
          createdBy: record.createdBy ?? userId,
          isActive: record.isActive ? 1 : 0,
          remarks: record.remarks,
        });
      }

      await dispatch(fetchPayrollEntityList("batchManagement"));

      return;
    }

    if (entityKey === "payrollComponents") {
      if (isEdit) {
        await payRollService.UpdatePayRollComponent({
          id: record.id,
          code: record.code,
          name: record.name,
          type: record.type,
          paymentType: record.paymentType,
          earningCategory: record.earningCategory,
          defaultAmount: record.calculationMethod === "F" ? record.defaultAmount : null,
          defaultPercentage: record.calculationMethod === "P" ? record.defaultPercentage : null,
          isEpf: record.isEpf,
          isEtf: record.isEtf,
          isOT: record.isOT,
          isNoPay: record.isNoPay,
          taxable: record.taxable,
          calculationMethod: record.calculationMethod,
          createdBy: userId,
          remarks: record.remarks,
          // earningCategory: record.earningCategory,
          // sortOrder: record.sortOrder,

          salarySlipDescription: record.salarySlipDescription,
          description: record.description,
          accountNo: record.accountNo,
          isBatch: record.isBatch,
        });
      } else {
        await payRollService.AddPayRollComponent({
          code: record.code,
          name: record.name,
          type: record.type,
          paymentType: record.paymentType,
          earningCategory: record.earningCategory,
          defaultAmount: record.calculationMethod === "F" ? record.defaultAmount : null,
          defaultPercentage: record.calculationMethod === "P" ? record.defaultPercentage : null,
          isEpf: record.isEpf,
          isEtf: record.isEtf,
          isOT: record.isOT,
          isNoPay: record.isNoPay,
          taxable: record.taxable,
          calculationMethod: record.calculationMethod,
          createdBy: userId,
          remarks: record.remarks,

          salarySlipDescription: record.salarySlipDescription,
          description: record.description,
          accountNo: record.accountNo,
          isBatch: record.isBatch,
        });
      }

      // const response = await payRollService.GetPayRollComponentList();

      // const list = (response.data.ResultSet || []).map((item) => ({
      //   id: item.HPC_COMPONENT_ID,

      //   code: item.HPC_COMPONENT_CODE,
      //   name: item.HPC_COMPONENT_NAME,

      //   type:
      //     componentTypeMap[item.HPC_COMPONENT_TYPE] ??
      //     item.HPC_COMPONENT_TYPE,

      //   calcMethod:
      //     calculationMethodMap[item.HPC_CALCULATION_METHOD] ??
      //     item.HPC_CALCULATION_METHOD,

      //   defaultAmount: Number(item.HPC_DEFAULT_AMOUNT || 0),
      //   defaultPercentage: Number(item.HPC_DEFAULT_PERCENTAGE || 0),

      //   basic: item.HPC_IS_BASIC === "True",
      //   taxable: item.HPC_IS_TAXABLE === "True",
      //   epf: item.HPC_IS_EPF === "True",
      //   etf: item.HPC_IS_ETF === "True",
      //   otPayable: item.HPC_IS_OT === "True",

      //   printOnPayslip: item.HPC_PRINT_ON_PAYSLIP === "True",
      //   glAccountCode: item.HPC_GL_ACCOUNT_CODE,
      //   sortOrder: Number(item.HPC_SORT_ORDER || 0),
      //   status: item.HPC_IS_ACTIVE === "True" ? "Active" : "Inactive",
      //   remarks: item.HPC_REMARKS,
      // }));

      // dispatch({
      //   type: PAYROLL_LIST_SUCCESS,
      //   payload: {
      //     entityKey,
      //     list,
      //   }
      // })

      await dispatch(fetchPayrollEntityList("payrollComponents"));
      return;
    }

    if (entityKey === "employeeSalary") {
      if (isEdit) {
        await payRollService.UpdateEmployeeSalary({
          employeeSalaryId: record.id,

          // payrollPeriodId: record.payrollPeriodId,
          salaryReference: record.salaryReference,
          effectiveDate: record.effectiveDate,
          endDate: record.endDate,
          payFrequency: record.payFrequency,

          grossSalary: record.grossSalary,
          basicSalary: record.basic,

          workingDays: record.workingDays,
          // workingHours: record.workingHours,
          // hourlyRate: record.hourlyRate,
          dailyRate: record.dailyRate,

          isCurrent: record.isCurrent,
          isActive: record.isActive,

          approvedBy: record.approvedBy,
          updatedBy: userId,
          remarks: record.remarks,
        })

        await dispatch(fetchPayrollEntityList("employeeSalary"));

        return record.id;
      } else {
        const response = await payRollService.AddEmployeeSalary({
          employeeId: record.employeeId,
          // payrollPeriodId: record.payrollPeriodId,
          salaryReference: record.salaryReference,
          effectiveDate: record.effectiveDate,
          endDate: record.endDate,
          grossSalary: record.grossSalary,
          basicSalary: record.basic,
          workingDays: record.workingDays,
          // workingHours: record.workingHours,
          // hourlyRate: record.hourlyRate,
          dailyRate: record.dailyRate,
          isCurrent: record.isCurrent || 1,
          isActive: record.isActive || 1,
          payFrequency: record.payFrequency,
          approvedBy: record.approvedBy,
          remarks: record.remarks,
        });

        const resultMessage = response.data?.Result || "";

        const employeeSalaryId = resultMessage.match(/\d+/)?.[0];

        if (!employeeSalaryId) {
          throw new Error("Employee salary was saved, but no employee salary ID was returned.");
        }

        await dispatch(fetchPayrollEntityList("employeeSalary"));

        return employeeSalaryId;
      }
    }

    if (entityKey === "employeeSalaryComponents") {
      let response;

      if (isEdit) {
        response = await payRollService.UpdateEmployeeSalaryComponent({
          employeeSalaryComponentId: record.employeeSalaryComponentId,
          employeeSalaryId: record.employeeSalaryId,
          componentId: record.componentId,
          componentAmount: record.componentAmount,
          componentPercentage: record.componentPercentage,
          effectiveDate: record.effectiveDate,
          endDate: record.endDate,
          isActive: record.isActive,
          remarks: record.remarks,
        })
      } else {
        response = await payRollService.AddEmployeeSalaryComponent({
          employeeSalaryId: record.employeeSalaryId,
          componentId: record.componentId,
          amount: record.amount,
          percentage: record.percentage,
          effectiveDate: record.effectiveDate,
          endDate: record.endDate,
          isActive: record.isActive,
          remarks: record.remarks,
        });
      }

      if (response?.data?.StatusCode === 500) {
        throw new Error(response.data.Result || "Failed to save salary component.");
      }

      await dispatch(fetchPayrollEntityList("employeeSalaryComponents"));
      return;
    }

    if (entityKey === "loanManagement") {
      if (isEdit) {
        await payRollService.UpdateLoan({
          loanId: record.id,
          employeeId: record.employeeId,
          loanNo: record.loanNo,
          loanType: record.loanType,
          loanTypeId: record.loanTypeId,
          loanDescription: record.loanDescription,
          loanDate: record.loanDate || null,
          approvedDate: record.approvedDate,
          approvedBy: record.approvedBy || userId,
          loanAmount: record.loanAmount ?? record.amount,
          interestRate: record.interestRate,
          totalInterest: record.totalInterest,
          totalAmount: record.totalAmount,
          noOfInstallments: record.noOfInstallments ?? record.installments,
          installmentAmount: record.installmentAmount,
          startPeriodId: record.startPeriodId,
          balanceAmount: record.balanceAmount ?? record.balance,
          status: record.status === "Not Paid" ? "P" : (record.status === "Paid" ? record.statusCode : record.status),
          createdBy: record.createdBy ?? userId,
          isActive: record.isActive === true || record.isActive === 1  || record.isActive === "True" ? 1 : 0,
          remarks: record.remarks,
        });

        await dispatch(fetchPayrollEntityList("loanManagement"));

        return record.id;
      } else {
        const isLoanActive = record.isActive === true || record.isActive === 1 || record.isActive === "True";

        const response = await payRollService.AddLoan({
          employeeId: record.employeeId,
          loanNo: record.loanNo,
          loanType: record.loanType,
          loanTypeId: record.loanTypeId,
          loanDescription: record.loanDescription,
          // loanDate: record.loanDate,
          loanDate: record.loanDate || null,
          loanAmount: record.loanAmount,
          interestRate: record.interestRate,
          totalInterest: record.totalInterest,
          totalAmount: record.totalAmount,
          noOfInstallments: record.noOfInstallments,
          installmentAmount: record.installmentAmount,
          startPeriodId: record.startPeriodId,
          balanceAmount: record.balanceAmount,
          status: record.status,
          createdBy: userId,
          isActive: isLoanActive ? 1 : 0,
          remarks: record.remarks,
        });

        const resultMessage = response.data?.Result || "";

        const loanId = resultMessage.match(/\d+/)?.[0];

        if (!loanId) {
          throw new Error("Loan was saved, but no Loan ID was returned by the API.");
        }

        await dispatch(fetchPayrollEntityList("loanManagement"));

        return Number(loanId);
      }
    }

    if (entityKey === "overtimeEntry") {
      const basePayload = {
        employeeId: record.employeeId,
        payrollPeriodId: record.payrollPeriodId,
        otDate: record.otDate,
        otType: record.otType,
        startTime: record.startTime,
        endTime: record.endTime,
        totalHours: record.hours,
        otRate: record.rate,
        otAmount: record.amount,
        isApproved: record.isApproved,
        approvedBy: record.approvedBy || userId,
        createdBy: record.createdBy ?? userId,
        isActive: record.isActive !== false,
      };

      if (isEdit) {
        // Update carries the payroll link forward once one exists.
        const updatePayload = {
          ...basePayload,
          overtimeId: record.id,
        }

        // Only send payrollId when it has actually been filled in
        if (
          record.payrollId !== undefined &&
          record.payrollId !== null &&
          record.payrollId !== 0 &&
          String(record.payrollId).trim() !== ""
        ) {
          updatePayload.payrollId = record.payrollId
        }

        await payRollService.UpdateOvertime(updatePayload)
      } else {

        await payRollService.AddOvertime(basePayload);
      }

      // const response = await payRollService.GetOvertimeList();
      // const list = (response.data.ResultSet || response.data.resultSet || []).map(mapOvertimeRow);

      // dispatch({
      //   type: PAYROLL_LIST_SUCCESS,
      //   payload: { entityKey, list },
      // });

      await dispatch(fetchPayrollEntityList("overtimeEntry"));

      return;
    }

    if (entityKey === "loanInstallments") {
      await payRollService.AddLoanInstallment({
        p_loanId: record.loanId,
        p_installmentNo: record.installmentNo,
        p_payrollPeriodId: record.payrollPeriodId,
        p_dueDate: record.dueDate,
        p_installmentAmt: record.installmentAmount,
        p_paidAmount: record.paidAmount,
        p_balanceAmt: record.balanceAmount,
        p_installmentStatus: record.status,
        p_payrollId: record.payrollId || null,
        p_installmentCreatedBy: "SYSTEM",
        p_installmentIsActive: 1,
        p_installmentRemarks: record.remarks,
      });

      return;
    }

    await delay();

    dispatch({
      type: PAYROLL_SAVE_SUCCESS,
      payload: { entityKey, record, isEdit },
    });

    return record;
  } catch (error) {
    dispatch({
      type: PAYROLL_SAVE_FAIL,
      payload: { entityKey, msg: error.message || error.toString() },
    });
    throw error;
  }
};

export const fetchLoanList = createAsyncThunk(
  "payroll/fetchLoanList",
  async (isActive = 1, { rejectWithValue }) => {
    try {
      const response = await payRollService.GetLoanList(isActive);

      const list = (response.data.ResultSet || []).map(item => ({
        id: item.HLM_LOAN_ID,

        employeeId: item.HLM_EMPLOYEE_ID,
        empNo: item.HED_SERVICE_NO,
        name: item.HED_REPORT_NAME,

        loanNo: item.HLM_LOAN_NO,
        loanType: item.HLM_LOAN_TYPE,
        loanTypeId: item.HLM_LOAN_TYPE_ID,
        loanDescription: item.HLM_LOAN_DESCRIPTION,

        loanDate: item.HLM_LOAN_DATE?.split(" ")[0],
        approvedDate: item.HLM_APPROVED_DATE?.split(" ")[0],

        amount: Number(item.HLM_LOAN_AMOUNT || 0),
        interestRate: Number(item.HLM_INTEREST_RATE || 0),
        totalInterest: Number(item.HLM_TOTAL_INTEREST || 0),
        totalAmount: Number(item.HLM_TOTAL_AMOUNT || 0),

        installments: Number(item.HLM_NO_OF_INSTALLMENTS || 0),
        installmentAmount: Number(item.HLM_INSTALLMENT_AMOUNT || 0),

        startPeriodId: item.HLM_START_PERIOD_ID,
        endPeriodId: item.HLM_END_PERIOD_ID,

        balance: Number(item.HLM_BALANCE_AMOUNT || 0),

        status: item.HLM_STATUS === "P" ? "Not Paid" : "Paid",

        approvedBy: item.HLM_APPROVED_BY,
        createdBy: item.HLM_CREATED_BY,

        isActive: item.HLM_IS_ACTIVE === "True",
        remarks: item.HLM_REMARKS,
      }));

      return list;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch loans.")
    }
  }
)